<ng-container *ngIf="dispDialog; else kymw1100content">
  <table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
    [frontDispFlag]="false">
    <tr class="subwindow-title" cdkDragHandle>
      <th class="window-title-name">商品マスタ</th>
      <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
    </tr>
    <tr class="subwindow-body">
      <td>
        <ng-container *ngIf="dispDialog; then kymw1100content"></ng-container>
      </td>
    </tr>
    <tfoot cdkDragHandle>
      <tr>
        <td>
          <div class="footer-buttons">
            <button id="btn_Out" class="btn-secondary" #btn_Out [disabled]="!kymw1100Model.btnOutEnabled"
            (click)="eventOutHandler()" forcedEnabledMode="none" [tabindex]="0">出力</button>
            <button id="btn_Delete" #btn_Delete class="btn-tartiary warning" [disabled]="true" [tabindex]="0"
              (click)="eventDelete_CLICKHandler()">削除</button>
            <button id="btn_eBASE" #btn_eBASE class="btn-secondary" forcedEnabledMode="none" [tabindex]="0"
              (click)="eventEBASE_CLICKHandler()">eBASEデータ</button>
            <button id="btn_Print" #btn_Print [tabindex]="0" class="btn-secondary" forcedEnabledMode="true"
              (click)="eventPrint_CLICKHandler()" (keydown)="initTabKey($event)">印刷</button>
            <button id="btn_StatusUpdate" class="btn-primary" #btn_StatusUpdate forcedEnabledMode="none" [tabindex]="0"
              (click)="eventStatusUpdate_CLICKHandler()">更新</button>
          </div>
          <div class="window-title-close">
            <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
            <button [tabindex]="0" (click)="onClickWindowClose()"></button>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</ng-container>

<ng-template #kymw1100content >
  <div class="contents-area" [style.background]="kymw1100Model.color">
    <wj-tab-panel id="tab_KYMW1100" #tab_KYMW1100 (selectedTabChange)="selectedTabKymw1100Change()">
      <wj-tab>
        <a #a_CandidateGoodsListTab>候補リスト</a>
        <div class="candidate-container">
          <button id="btn_Seach" #btn_Seach [tabindex]="0" class="btn-secondary" forcedEnabledMode="true"
            (click)="eventSearch_CLICKHandler()">商品検索</button>
          <div class="action-area">
            <div class="guide-label">
              <label class="lbl_usually">通常のデータ(編集可)</label>
              <label class="lbl_using">他のユーザーが編集中のデータ</label>
              <label class="lbl_expire">取扱終了日指定ありのデータ</label>
            </div>
            <app-pager [prevDisabled]="!kymw1100Model.btnBackEnabled" [nextDisabled]="!kymw1100Model.btnNextEnabled"
              [totalNum]="kymw1100Model.totalNum" [startNum]="kymw1100Model.startDispNum"
              [endNum]="kymw1100Model.endDispNum" (prevHandler)="eventBackHandler(null)"
              (nextHandler)="eventNextHandler()">
            </app-pager>
          </div>
          <!-- データグリッド定義(候補一覧) -->
          <wj-flex-grid #dtg_CandidateGoodsList [itemsSource]="kymw1100Model.candidateGoodsList"
            [style.height.px]="705" id="dtg_CandidateGoodsList" [headersVisibility]="'Column'" [isReadOnly]="true"
            [allowSorting]="false" [headersVisibility]="'Column'" [allowDragging]="'None'" forcedEnabledMode="true"
            [tabindex]="0" (click)="eventCandidateGoodsListHandler($event, dtg_CandidateGoodsList);" class="always-scrollbars">
            <wj-flex-grid-column [minWidth]="5" [width]="90" [binding]="'Pcode'" [header]="'Ｐコード'" [cellTemplate]="lnk_PCode">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="231" [binding]="'GuideGoodsName'" [header]="'商品名'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="220" [binding]="'GuideStandardName'" [header]="'規格名'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'LatestOrderCode'" [header]="'最新受注コード'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="169" [binding]="'LatestDelivCatalogId'" [header]="'最新配達企画回(翌週)'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="140" [binding]="'FirstOrderCode'" [header]="'初回受注コード'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="169" [binding]="'FirstDelivCatalogId'" [header]="'初回配達企画回(翌週)'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="32" [align]="'center'" [binding]="'HandlingCoop1'"
              [header]="'い'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="32" [align]="'center'" [binding]="'HandlingCoop2'"
              [header]="'と'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="32" [align]="'center'" [binding]="'HandlingCoop3'"
              [header]="'ぐ'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="32" [align]="'center'" [binding]="'HandlingCoop4'"
              [header]="'ち'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="32" [align]="'center'" [binding]="'HandlingCoop5'"
              [header]="'さ'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="35" [align]="'center'" [binding]="'HandlingCoop6'"
              [header]="'とう'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="32" [align]="'center'" [binding]="'HandlingCoop7'"
              [header]="'な'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="32" [align]="'center'" [binding]="'HandlingCoop8'"
              [header]="'に'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'RegistDate'" [header]="'登録日'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'UpdateDate'" [header]="'更新日'">
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </wj-tab>
      <wj-tab>
        <a #a_GoodsMasterTab>商品マスタメンテナンス</a>
        <div class="block-column" style="width: 1623px;">
          <div class="element-row" style="align-items: center;">
            <button id="btn_GoodsPCode" #btn_GoodsPCode class="btn-secondary" [tabindex]="0" forcedEnabledMode="none"
              (click)="eventGoodsPCode_CLICKHandler()" (keydown)="initTabKey($event)">新規作成</button>
            <button id="btn_Copy" #btn_Copy class="btn-secondary" [disabled]="true" [tabindex]="0"
              (click)="eventCopy_CLICKHandler()">コピー</button>
            <button id="btn_History" #btn_History class="btn-secondary" [disabled]="true" [tabindex]="0"
              (click)="eventHistory_CLICKHandler()">実績履歴</button>
            <button id="btn_himotuke" #btn_himotuke class="btn-secondary" [disabled]="true" [tabindex]="0"
              (click)="eventHimotuke_CLICKHandler()">紐付</button>
            <button id="btn_Image" #btn_Image class="btn-secondary" [disabled]="true" [tabindex]="0"
              (click)="eventImage_CLICKHandler()">画像確認</button>
            <button id="btn_Image2" #btn_Image2 class="btn-secondary" [disabled]="true" [tabindex]="0"
              (click)="eventImage2_CLICKHandler()">画像作成</button>
            <button id="btn_GoodsInfoOut" #btn_GoodsInfoOut class="btn-secondary" [disabled]="true" [tabindex]="0"
              (click)="eventStatusOut_CLICKHandler()">情報出力</button>
            <button id="btn_ProofOut" #btn_ProofOut class="btn-secondary" [disabled]="true" [tabindex]="0"
              (click)="eventStatusProofOut_CLICKHandler()">プルーフ</button>
            <button id="btn_MultiGoods" #btn_MultiGoods class="btn-secondary" [disabled]="true" [tabindex]="0"
              (click)="eventMultiGoods_CLICKHandler()">マルチ設定</button>
            <app-code-combo-box [codeDiv]="'ctp022'" [labelField]="'codeValueName'" id="cmb_RatechangeBox" #cmb_RatechangeBox
              [subid]="'cmb_RatechangeBox'" [tabindex]="-1" [blank]="false" [required]="true" [forcedEnabledMode]="'none'"
              [disabled]="isDisableChangeTax()" [width]="'17rem'"
              [(ngModel)]="kymw1100Model.ratechangeBox" (change)="eventRateChange_CLICKHandler()">
            </app-code-combo-box>
          </div>
  
          <div class="split_two_part">
            <div id="cnv_info1" class="block-column" [class.div-disabled-style]="!kymw1100Model.enabledInfo1Flg">
              <div class="element-column">
                <div class="block-row">
                  <div class="column-list">
                    <label class="list-input-title" style="width: 100px;">Pコード</label>
                    <div class="list-input-content">
                      <input type="text" id="txti_Pcode" #txti_Pcode plessInputTextSub [restrict]="'[ -￮]'"
                        [(ngModel)]="kymw1100Model.pCode" class="pcode" readonly/>
                      <app-radio-label label="eBASE取込後" id="rdb_AdmitStatus0" #rdb_AdmitStatus0 [subid]="'rdb_AdmitStatus0'"
                        name="radiogroup" forcedEnabledMode="none" [tabindex]="0" [(ngModel)]="kymw1100Model.admitStatus"
                         value="0" (change)="eventAdmitStatus0Handler()">
                      </app-radio-label>
                      <app-radio-label label="仮登録" id="rdb_AdmitStatus1" #rdb_AdmitStatus1 [subid]="'rdb_AdmitStatus1'"
                        name="radiogroup" forcedEnabledMode="none" [tabindex]="0" [(ngModel)]="kymw1100Model.admitStatus"
                        value="1" (change)="eventAdmitStatus0Handler()">
                      </app-radio-label>
                      <app-radio-label label="本登録" id="rdb_AdmitStatus2" #rdb_AdmitStatus2 [subid]="'rdb_AdmitStatus2'"
                        name="radiogroup" forcedEnabledMode="none" [tabindex]="0" [(ngModel)]="kymw1100Model.admitStatus"
                        value="2" (change)="eventAdmitStatus2Handler()">
                      </app-radio-label>
                    </div>
                  </div>
                </div>
                <div class="block-row">
                  <div class="element-column">
                    <div class="column-list">
                      <label class="list-input-title" style="width: 100px;">バイヤー</label>
                      <div class="list-input-content">
                        <app-code-combo-box id="cmb_BuyerCode" #cmb_BuyerCode [subid]="'cmb_BuyerCode'" [width]="258"
                          [codeDiv]="'ct357'" [labelField]="'codeValueName'" [required]="true" [forcedEnabledMode]="'true'"
                          [tabindex]="0" [autofocus]="true" [(ngModel)]="kymw1100Model.buyerCode">
                        </app-code-combo-box>
                      </div>
                      <label class="list-input-title">部門</label>
                      <div class="list-input-content">
                        <app-class-code-combo-box #cmb_ClassCode id="cmb_ClassCode" [subid]="'cmb_ClassCode'" [width]="258" [required]="true"
                          [forcedEnabledMode]="'true'" [tabindex]="0" [blank]="true" (change)="eventClassCodeComboBoxHandler()">
                        </app-class-code-combo-box>
                      </div>
                    </div>
                    <div class="block-row">
                      <div class="column-list">
                        <label class="list-input-title">包材一括表示</label>
                        <div class="list-input-content">
                          <label><input type="checkbox" id="chk_PackMaterialShowFlg" #chk_PackMaterialShowFlg
                            [(ngModel)]="kymw1100Model.packMaterialShowFlg" forcedEnabledMode="none"  [tabindex]="0"
                            (change)="eventPackMaterialShowFlgHandler()"/>確認済</label>
                        </div>
                      </div>
                      <div class="column-list">
                        <label class="list-input-title" style="width: 100px;">ダミー商品</label>
                        <div class="list-input-content">
                          <input type="checkbox" id="chk_DummyGoods" #chk_DummyGoods forcedEnabledMode="none" [tabindex]="0"
                            [(ngModel)]="kymw1100Model.dummyGoods"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column-list" style="width: 355px;">
                    <label class="list-input-title" style="width: 100px;">大分類</label>
                    <div class="list-input-content">
                      <app-large-class-code-combo-box #cmb_LargeClassCode id="cmb_LargeClassCode" [subid]="'cmb_LargeClassCode'"
                        [forcedEnabledMode]="'true'" [tabindex]="0" [blank]="true" [classCode]="cmb_ClassCode.selectedClassCode"
                        [required]="true" [classCodeComboBoxFlg]="true">
                      </app-large-class-code-combo-box>
                    </div>
                    <label class="list-input-title">中分類</label>
                    <div class="list-input-content">
                      <app-middle-class-code-combo-box #cmb_MiddleClassCode [subid]="'cmb_MiddleClassCode'"
                        id="cmb_MiddleClassCode" [blank]="true" [forcedEnabledMode]="'true'" [tabindex]="0"
                        [classCode]="cmb_ClassCode.selectedClassCode" [required]="true"
                        [largeClassCode]="cmb_LargeClassCode.selectedLargeClassCode" [classCodeComboBoxFlg]="true"
                        [largeClassCodeComboBoxFlg]="true">
                      </app-middle-class-code-combo-box>
                    </div>
                    <label class="list-input-title">小分類</label>
                    <div class="list-input-content">
                      <app-small-class-code-combo-box #cmb_SmallClassCodeList [subid]="'cmb_SmallClassCodeList'"
                        id="cmb_SmallClassCodeList" [required]="true" [forcedEnabledMode]="'true'" [tabindex]="0" [blank]="true"
                        [classCodeComboBoxFlg]="true" [largeClassCodeComboBoxFlg]="true"
                        [classCode]="cmb_ClassCode.selectedClassCode"
                        [largeClassCode]="cmb_LargeClassCode.selectedLargeClassCode"
                        [middleClassCode]="cmb_MiddleClassCode.selectedMiddleClassCode"
                        (change)=" eventSmallClassCodeComboBoxHandler()" >
                      </app-small-class-code-combo-box>
                    </div>
                  </div>
                </div>
                <div class="block-row">
                  <div class="column-list">
                    <label class="list-input-title" style="width: 100px;">ECカテゴリ</label>
                    <div class="list-input-content">
                      <app-goods-ec-category-code-combo-box id="cmb_CategoryCode" style="width: 265px"
                        [subid]="'cmb_CategoryCode'" [categoryDiv]="'0'" [initFocusItem]="txti_GuideGoodsName" [blank]="true"
                        [forcedEnabledMode]="'true'" [tabindex]="0" #cmb_CategoryCode [(ngModel)]="kymw1100Model.categoryCode">
                      </app-goods-ec-category-code-combo-box>
                    </div>
                  </div>
                </div>
                <div class="column-list">
                  <div class="list-input-title layout_balance">
                    <label>商品案内用商品名</label>
                    <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                      <fa-icon [icon]="iconQuestion"></fa-icon>
                    </label>
                  </div>
                  <div class="list-input-content">
                    <app-not-null-text-input id="txti_GuideGoodsName" #txti_GuideGoodsName [subid]="'txti_GuideGoodsName'"
                      [fullOnly]="true" [maxChars]="30" [forcedEnabledMode]="'true'" [tabindex]="0" [restrict]="'[ -￮]'"
                      [(ngModel)]="kymw1100Model.guideGoodsName" class="guide-goods-name"
                      (blur)="eventGuideGoodsNameHandler($event)">
                    </app-not-null-text-input>
                  </div>
                  <div class="list-input-title layout_balance">
                    <label>商品案内用規格名</label>
                    <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                      <fa-icon [icon]="iconQuestion"></fa-icon>
                    </label>
                  </div>
                  <div class="list-input-content">
                    <app-not-null-text-input id="txti_GuideStandardName" #txti_GuideStandardName
                      [subid]="'txti_GuideStandardName'" [fullOnly]="true" [maxChars]="15" [forcedEnabledMode]="'true'"
                      [tabindex]="0" [restrict]="'[ -￮]'" class="guide-standard-name"
                      [(ngModel)]="kymw1100Model.guideStandardName" (blur)="eventGuideStandardNameHandler($event)">
                    </app-not-null-text-input>
                  </div>
                  <label class="list-input-title">取扱期間</label>
                  <div class="list-input-content">
                    <wj-input-date style="width:136px;" id="dtf_AppkyTermStart" #dtf_AppkyTermStart forcedEnabledMode="true"
                      [tabindex]="0" [isRequired]="false" [(text)]="kymw1100Model.appkyTermStart" format="yyyy/MM/dd"
                      class="text-label-required" (change)="eventAppkyTermStart_CLICKHandler()">
                    </wj-input-date>
                    <label>～</label>
                    <wj-input-date style="width:136px;" id="dtf_AppkyTermEnd" #dtf_AppkyTermEnd forcedEnabledMode="none"
                      [tabindex]="0" [isRequired]="false" [(text)]="kymw1100Model.appkyTermEnd" format="yyyy/MM/dd"
                      (change)="eventAppkyTermEnd_CLICKHandler()">
                    </wj-input-date>
                    <label>
                      <input type="checkbox" id="chk_EndFlag" #chk_EndFlag forcedEnabledMode="true" [tabindex]="0"
                        [(ngModel)]="kymw1100Model.endFlag" (change)="eventEndFlagHandler()"/>
                      <span>終了指定なし</span>
                    </label>
                  </div>
                </div>
              </div>
              <wj-tab-panel id="tab_pCode" #tab_pCode
                [class.div-disabled-style]="!kymw1100Model.enabledInfo1Flg" (selectedTabChange)="selectedTabPCodeChange()">
                <div>
                  <wj-tab>
                    <a #a_BaseInfoTab>基本情報</a>
                    <div class="block-column" id="cnv_BaseInfoTab" #cnv_BaseInfoTab>
                      <div class="element-column">
                        <div class="column-list">
                          <div class="list-input-title layout_balance">
                            <label>お届け明細書用商品名(漢字)</label>
                            <label aria-label="EC" data-microtip-position="bottom" role="tooltip" class="question">
                              <fa-icon [icon]="iconQuestion"></fa-icon></label>
                          </div>
                          <div class="list-input-content">
                            <app-not-null-text-input id="txti_DeliveryGoodsNameKanji" #txti_DeliveryGoodsNameKanji
                              [subid]="'txti_DeliveryGoodsNameKanji'" [restrict]="'[ -￮]'" [maxChars]="15" [fullOnly]="true"
                                [forcedEnabledMode]="'true'" [tabindex]="0" [width]="'17rem'"
                              [(ngModel)]="kymw1100Model.deliveryGoodsNameKanji">
                            </app-not-null-text-input>
                          </div>
                          <label class="list-input-title">発注用商品名(カナ)</label>
                          <div class="list-input-content">
                            <app-not-null-text-input [maxChars]="15" [halfOnly]="true" id="txti_DeliveryGoodsNameKana"
                              #txti_DeliveryGoodsNameKana [subid]="'txti_DeliveryGoodsNameKana'" [restrict]="'[ -￮]'"
                              [toUpperCase]="true" [forcedEnabledMode]="'true'" [tabindex]="0"
                              [width]="'17rem'" [(ngModel)]="kymw1100Model.deliveryGoodsNameKana"
                              (input)="eventDeliveryGoodsNameKana_deleteCommaHandler()"
                              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                            </app-not-null-text-input>
                          </div>
                          <label class="list-input-title">OCR商品名</label>
                          <div class="list-input-content">
                            <app-not-null-text-input [maxChars]="16" id="txti_OcrGoodsName" #txti_OcrGoodsName
                              [subid]="'txti_OcrGoodsName'" [fullOnly]="true" [restrict]="'[ -￮]'"
                              [forcedEnabledMode]="'true'" [tabindex]="0" [width]="'17rem'"
                              [(ngModel)]="kymw1100Model.ocrGoodsName">
                            </app-not-null-text-input>
                          </div>
                          <label class="list-input-title">お届け明細書用規格名(漢字)</label>
                          <div class="list-input-content">
                            <app-not-null-text-input [maxChars]="10" id="txti_DeliveryStandardNameKanji"
                              [subid]="'txti_DeliveryStandardNameKanji'" #txti_DeliveryStandardNameKanji [restrict]="'[ -￮]'"
                              [forcedEnabledMode]="'true'" [tabindex]="0" [fullOnly]="true"
                              [width]="'12rem'" [(ngModel)]="kymw1100Model.deliveryStandardNameKanji">
                            </app-not-null-text-input>
                          </div>
                          <label class="list-input-title">発注用規格名(カナ)</label>
                          <div class="list-input-content">
                            <app-not-null-text-input [maxChars]="10" [halfOnly]="true" id="txti_DeliveryStandardNameKana"
                              #txti_DeliveryStandardNameKana [subid]="'txti_DeliveryStandardNameKana'" [restrict]="'[ -￮]'"
                              [forcedEnabledMode]="'true'" [tabindex]="0" [toUpperCase]="true"
                              [width]="'12rem'" [(ngModel)]="kymw1100Model.deliveryStandardNameKana"
                              (input)="eventDeliveryStandardNameKana_deleteCommaHandler()"
                              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                            </app-not-null-text-input>
                          </div>
                          <label class="list-input-title">消費税区分/消費税率</label>
                          <div class="list-input-content">
                            <app-code-combo-box [required]="true" [codeDiv]="'ct016'" [labelField]="'codeValueName'"
                              id="cmb_ConsumeTaxDivList" #cmb_ConsumeTaxDivList [subid]="'cmb_ConsumeTaxDivList'"
                              [forcedEnabledMode]="'true'" [tabindex]="-1"
                              (change)="eventConsumeTaxDivList()">
                            </app-code-combo-box>
                            <input type="text" class="text-label-required" id="txti_ConsumeTaxDivRate" #txti_ConsumeTaxDivRate
                              plessInputTextSub [restrict]="'[0-9]'" [maxlength]="2" forcedEnabledMode="true" [tabindex]="-1"
                              [style.width.rem]="3" [(ngModel)]="kymw1100Model.consumeTaxDivRateScreen"
                              (blur)="eventConsumeTaxDivRate($event)" />
                          </div>
                          <label class="list-input-title">サイクル期間</label>
                          <div class="list-input-content">
                            <app-code-combo-box [codeDiv]="'ct290'" [labelField]="'codeValueName'" id="cmb_CycleTerm"
                              #cmb_CycleTerm [subid]="'cmb_CycleTerm'" [forcedEnabledMode]="'true'" [tabindex]="-1"
                              [(ngModel)]="kymw1100Model.cycleTerm">
                            </app-code-combo-box>
                          </div>
                          <label class="list-input-title">ユニットプライス区分</label>
                          <div class="list-input-content">
                            <app-code-combo-box [codeDiv]="'ct287'" [labelField]="'codeValueName'" id="cmb_UnitPriceDiv"
                              #cmb_UnitPriceDiv [subid]="'cmb_UnitPriceDiv'" [forcedEnabledMode]="'true'" [tabindex]="0"
                              [(ngModel)]="kymw1100Model.unitPriceDiv" [blank]="false">
                            </app-code-combo-box>
                          </div>
                          <div class="list-input-title">
                            <label>ユニットプライス単位</label>
                          </div>
                          <div class="list-input-content">
                            <app-text-input [maxChars]="15" [restrict]="'[ -￮]'" id="txti_UnitPriceUnit" #txti_UnitPriceUnit
                              [subid]="'txti_UnitPriceUnit'" [fullOnly]="true" [forcedEnabledMode]="'true'" [tabindex]="0"
                              [(ngModel)]="kymw1100Model.unitPriceUnit" [style.width.rem]="20">
                            </app-text-input>
                          </div>
                          <div class="list-input-title layout_balance">
                            <label>ユニットプライス係数</label>
                            <label aria-label='誌面＋EC：ユニットプライス区分="1"のときユニットプライスが連携される' data-microtip-position="top-right" role="tooltip"
                              class="question">
                              <fa-icon [icon]="iconQuestion"></fa-icon></label>
                          </div>
                          <div class="list-input-content">
                            <input type="text" id="txti_UnitPriceCoefficient" #txti_UnitPriceCoefficient plessInputTextSub
                              [restrict]="'[0-9\.]'" [maxlength]="8" forcedEnabledMode="true" [tabindex]="0"
                              [(ngModel)]="kymw1100Model.unitPriceCoefficient"
                              [style.width.rem]="7"/>
                          </div>
                        </div>
                        <div class="element-column">
                          <div class="block-row">
                            <div class="column-list" style="width: 422px;">
                              <label class="list-input-title">EDLP商品区分</label>
                              <div class="list-input-content">
                                <app-code-combo-box [codeDiv]="'ct374'" [labelField]="'codeValueName'" id="cmb_EdlpDiv"
                                  #cmb_EdlpDiv [subid]="'cmb_EdlpDiv'" [forcedEnabledMode]="'true'" [tabindex]="0"
                                  [blank]="false" [(ngModel)]="kymw1100Model.edlpDiv">
                                </app-code-combo-box>
                              </div>
                              <div class="list-input-title layout_balance" style="width: 142px;">
                                <label>賞味期間</label>
                                <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                  <fa-icon [icon]="iconQuestion"></fa-icon></label>
                              </div>
                              <div class="list-input-content">
                                <input type="text" id="txti_ConsumeTerm" #txti_ConsumeTerm plessInputTextSub
                                  [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="true" [tabindex]="0"
                                  [style.width.rem]="4" [(ngModel)]="kymw1100Model.consumeTerm"/>
                              </div>
                              <div class="list-input-title layout_balance">
                                <label>消費期限</label>
                                <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                  <fa-icon [icon]="iconQuestion"></fa-icon></label>
                              </div>
                              <div class="list-input-content">
                                <input type="text" id="txti_ConsumeByDate" #txti_ConsumeByDate plessInputTextSub
                                  [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="true" [tabindex]="0"
                                  [style.width.rem]="4" [(ngModel)]="kymw1100Model.consumeByDate"/>
                              </div>
                              <label class="list-input-title">残賞味期間</label>
                              <div class="list-input-content">
                                <input type="text" id="txti_LeaveConsumeTerm" #txti_LeaveConsumeTerm plessInputTextSub
                                  [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="true" [tabindex]="-1"
                                  [style.width.rem]="4" [(ngModel)]="kymw1100Model.leaveConsumeTerm" />
                              </div>
                            </div>
                            <div class="column-list">
                              <label class="list-input-title" style="width: 142px;">商品案内温度帯区分</label>
                              <div class="list-input-content">
                                <app-code-combo-box [codeDiv]="'ct061'" [labelField]="'codeValueName'" id="cmb_GuideTempZoneDiv"
                                  #cmb_GuideTempZoneDiv [subid]="'cmb_GuideTempZoneDiv'" [forcedEnabledMode]="'true'"
                                  [tabindex]="0" [(ngModel)]="kymw1100Model.guideTempZoneDiv">
                                </app-code-combo-box>
                              </div>
                              <label class="list-input-title">eフレンズ送信</label>
                              <div class="list-input-content">
                                <label>
                                  <input type="checkbox" id="chk_eFriendsSendDiv" #chk_eFriendsSendDiv forcedEnabledMode="false"
                                    [tabindex]="0" [(ngModel)]="kymw1100Model.eFriendsSendDiv" />
                                  <span>送信不要</span>
                                </label>
                              </div>
                              <label class="list-input-title">目隠し区分</label>
                              <div class="list-input-content">
                                <app-code-combo-box [codeDiv]="'ct353'" [labelField]="'codeValueName'" id="cmb_BlindDiv"
                                  #cmb_BlindDiv [subid]="'cmb_BlindDiv'" [forcedEnabledMode]="'true'" [tabindex]="0"
                                  [(ngModel)]="kymw1100Model.blindDiv">
                                </app-code-combo-box>
                              </div>
                              <label class="list-input-title">EC非表示区分</label>
                              <div class="list-input-content">
                                <app-code-combo-box [codeDiv]="'ctp131'" [labelField]="'codeValueName'" id="cmb_EcNonDispDiv"
                                  #cmb_EcNonDispDiv [subid]="'cmb_EcNonDispDiv'" [forcedEnabledMode]="'true'" [tabindex]="0"
                                  [blank]="false" [(ngModel)]="kymw1100Model.ecNonDispDiv">
                                </app-code-combo-box>
                              </div>
                            </div>
                          </div>
                          <div class="column-list">
                            <label class="list-input-title" style="width: 142px;">季節消費期限</label>
                            <div class="list-input-content">
                              <label>
                                <input type="checkbox" id="chk_SeasonConsumeDiv" #chk_SeasonConsumeDiv forcedEnabledMode="true"
                                  [tabindex]="0" [(ngModel)]="kymw1100Model.seasonConsumeDiv"
                                  (change)="eventSeasonConsumeDivHandler()"/>
                                <input type="text" id="txti_SeasonConsumeTerm" #txti_SeasonConsumeTerm plessInputTextSub
                                  [style.width.rem]="4" [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="none"
                                  [tabindex]="0" [disabled]="true" [(ngModel)]="kymw1100Model.seasonConsumeTerm"/>
                              </label>
                              <wj-input-date [isRequired]="false" [tabindex]="0" [style.width.rem]="7"
                                id="dtf_SeasonConsumeTermFrom" #dtf_SeasonConsumeTermFrom
                                [(text)]="kymw1100Model.seasonConsumeTermFrom" format="MMdd">
                              </wj-input-date>
                              <label>～</label>
                              <wj-input-date [isRequired]="false" id="dtf_SeasonConsumeTermTo" #dtf_SeasonConsumeTermTo
                                forcedEnabledMode="none" [tabindex]="0" [style.width.rem]="7"
                                [(text)]="kymw1100Model.seasonConsumeTermTo" format="MMdd">
                              </wj-input-date>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h3>関連Ｐコード</h3>
                        <div class="block-row">
                          <div class="column-list">
                            <label class="list-input-title" style="width: 142px;">関連Ｐコード(旧)</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_RelationPcodeOld" readonly
                                #txti_RelationPcodeOld [tabindex]="0"
                                plessInputTextSub [restrict]="'[ -￮]'" [(ngModel)]="kymw1100Model.relationPcodeOld" class="pcode" />
                              <button id="btn_RelationPcode" class="btn-secondary" #btn_RelationPcode [disabled]="false"
                              [tabindex]="0" (click)="eventRelationPcode_CLICKHandler()">設定</button>
                            </div>
                          </div>
                          <div class="column-list">
                            <label class="list-input-title" style="width: 142px;">関連Ｐコード(新)</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_RelationPcodeNew"  readonly
                                #txti_RelationPcodeNew [tabindex]="0"
                                plessInputTextSub [restrict]="'[ -￮]'" [(ngModel)]="kymw1100Model.relationPcodeNew" class="pcode" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h3>酒税法関連</h3>
                        <div class="block-row">
                          <div class="column-list" style="width: 422px;">
                            <label class="list-input-title" style="width: 142px;">酒類コード</label>
                            <div class="list-input-content">
                              <app-code-combo-box [codeDiv]="'ct362'" [labelField]="'codeValueName'" id="cmb_LiquorCode"
                                #cmb_LiquorCode [subid]="'cmb_LiquorCode'" [forcedEnabledMode]="'true'" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.liquorCode">
                              </app-code-combo-box>
                            </div>
                            <label class="list-input-title">容器形態</label>
                            <div class="list-input-content">
                              <app-code-combo-box [codeDiv]="'ct360'" [labelField]="'codeValueName'" id="cmb_ContainerForm"
                                #cmb_ContainerForm [subid]="'cmb_ContainerForm'" [forcedEnabledMode]="'true'" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.containerForm">
                              </app-code-combo-box>
                            </div>
                          </div>
                          <div class="column-list">
                            <label class="list-input-title" style="width: 142px;">アルコール分別</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_AlocoholType" #txti_AlocoholType plessInputTextSub
                                [restrict]="'[0-9\.]'" [maxlength]="8" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.alocoholType" [style.width.rem]="7" />
                            </div>
                            <label class="list-input-title">供給単位総容量</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_ContainerCapacity" #txti_ContainerCapacity plessInputTextSub
                                [restrict]="'[0-9]'" [maxlength]="5" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.containerCapacity" (keydown)="nextFocus($event)" [style.width.rem]="7" />
                              <label>ml</label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="element-column">
                        <div class="column-list">
                          <div class="list-input-title" style="width: 142px;">
                            <label>メイン取扱媒体</label>
                          </div>
                          <div class="layout_balance checkbox_btn_beside">
                            <button class="btn-secondary" id="btn_MediumType" #btn_MediumType
                              forcedEnabledMode="none" [tabindex]="0"
                              (click)="eventMediumType_CLICKHandler()">掲載媒体設定</button>
                          </div>
                        </div>
                        <div class="list-input-content">
                          <app-text-area [disabled]="true" [restrict]="'[ -￮]'" [allowMultiLine]="false"
                            id="txta_MediumText" #txta_MediumText [subid]="'txta_MediumText'" [forcedEnabledMode]="'none'"
                            [tabindex]="-1" [counterWidth]="'60px'" [(ngModel)]="kymw1100Model.mediumText" [displayCountField]="false"
                            [height]="90">
                          </app-text-area>
                        </div>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_MarkInfoTab>マーク情報</a>
                    <div class="column-list">
                      <div class="list-input-title layout_balance">
                        <label>マーク情報</label>
                        <label aria-label="誌面" data-microtip-position="bottom" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <div class="grid-container" [style.height.px]="!dispDialog ? 171: 162"> 
                        <wj-flex-grid #dtg_Mark id="dtg_Mark" [tabindex]="0" [isReadOnly]="true" [style.width.px]="703"
                          [itemsSource]="kymw1100Model.markList" [headersVisibility]="'Column'">
                          <wj-flex-grid-column [minWidth]="5" [width]="50" [align]="'center'" [binding]="'Check'"
                            [header]="'設定'" [allowSorting]="false" [isReadOnly]="true">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                              <input type="checkbox" [(ngModel)]="cell.item.Check" [tabindex]="-1"
                                id="cb_mark_{{cell.row.index}}" (mouseup)="$event.stopPropagation()"
                                (change)="kymw1100Model.updateSelectedMarkInfo();eventEditHandler();" />
                            </ng-template>
                          </wj-flex-grid-column>
                          <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'MarkCode'" [header]="'マークコード'">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                              <app-mark-code [Data]="cell.item">
                              </app-mark-code>
                            </ng-template>
                          </wj-flex-grid-column>
                          <wj-flex-grid-column [minWidth]="5" [width]="536" [binding]="'MarkName'" [header]="'マーク内容'"
                            [tabindex]="-1">
                          </wj-flex-grid-column>
                        </wj-flex-grid>
                      </div>
  
                      <label class="list-input-title">選択マーク一覧</label>
                      <div class="grid-container" [style.height.px]="!dispDialog ? 171: 161">
                        <wj-flex-grid #dtg_SelectedMark id="dtg_SelectedMark" [allowSorting]="false" [style.width.px]="703"
                          [allowDragging]="'None'" [isReadOnly]="true" [tabindex]="0" [itemsSource]="kymw1100Model.selectedMark"
                          [allowMerging]="'ColumnHeaders'" [headersVisibility]="'Column'"  [autoSizeMode]="2"
                          (keydown)="nextFocus($event)" (updatingView)="onSourceChangeSelectedMark()"
                          (resizedColumn)="onResizedColumn(dtg_SelectedMark,$event)" class="always-scrollbars">
                          <wj-flex-grid-column [minWidth]="5" [width]="150" [binding]="'Caption'" [header]="'マークグループ'">
                          </wj-flex-grid-column>
                          <wj-flex-grid-column [minWidth]="5" [width]="536" [binding]="'MarkName'" [header]="'マーク内容'"
                            [wordWrap]=true>
                          </wj-flex-grid-column>
                        </wj-flex-grid>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_AddInfoTab>付加情報</a>
                    <div id="cnv_AddInfoTab" #cnv_AddInfoTab>
                      <div class="input_vertical">
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>商品説明</label>
                              <label aria-label="誌面＋EC" data-microtip-position="bottom" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="layout_balance checkbox_btn_beside">
                              <div class="label_checkbox">
                                <label id="lbl_Cnt_TextInfo1" #lbl_Cnt_TextInfo1>{{kymw1100Model.textInfoCnt1}}</label>
                              </div>
                              <button class="btn-secondary" id="lnb_TextInfo1" #lnb_TextInfo1 forcedEnabledMode="none"
                                [tabindex]="0" (click)="eventTextInfo_CLICKHandler($event)">候補を表示</button>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [fullOnly]="true" [disabled]="true" [restrict]="'[ -￮]'" [maxChars]="200"
                              [counterWidth]="'60px'" id="txta_TextInfo1" #txta_TextInfo1 [subid]="'txta_TextInfo1'"
                              forcedEnabledMode="false" [allowMultiLine]="false" [tabindex]="-1"
                              [(ngModel)]="kymw1100Model.textInfo1" [height]="90">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>キャッチコピー</label>
                              <label aria-label="誌面＋EC" 
                                data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="layout_balance checkbox_btn_beside">
                              <div class="label_checkbox">
                                <label id="lbl_Cnt_TextInfo2" #lbl_Cnt_TextInfo2>{{kymw1100Model.textInfoCnt2}}</label>
                              </div>
                              <button class="btn-secondary" forcedEnabledMode="none" [tabindex]="0" id="lnb_TextInfo2"
                                #lnb_TextInfo2 (click)="eventTextInfo_CLICKHandler($event)">候補を表示</button>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [disabled]="true" [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo2"
                              [counterWidth]="'60px'" #txta_TextInfo2 [subid]="'txta_TextInfo2'" [maxChars]="200"
                              forcedEnabledMode="false" [allowMultiLine]="false" [tabindex]="-1"
                              [(ngModel)]="kymw1100Model.textInfo2" [height]="90">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>おすすめコメント(吹き出し)</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="layout_balance checkbox_btn_beside">
                              <div class="label_checkbox">
                                <label id="lbl_Cnt_TextInfo3" #lbl_Cnt_TextInfo3>{{kymw1100Model.textInfoCnt3}}</label>
                              </div>
                              <button class="btn-secondary" id="lnb_TextInfo3" #lnb_TextInfo3 forcedEnabledMode="none"
                                [tabindex]="0" (click)="eventTextInfo_CLICKHandler($event)">候補を表示</button>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [disabled]="true" [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo3"
                              [counterWidth]="'60px'" #txta_TextInfo3 [subid]="'txta_TextInfo3'" [maxChars]="200"
                              forcedEnabledMode="false" [allowMultiLine]="false" [tabindex]="-1"
                              [(ngModel)]="kymw1100Model.textInfo3" [height]="90">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>便利情報(囲み)</label>
                              <label aria-label="誌面＋EC" 
                                data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo4" #txta_TextInfo4
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo4'" [maxChars]="200" forcedEnabledMode="true"
                              [allowMultiLine]="false" [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo4"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" [height]="90">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>便利情報(商品構成内容)</label>
                              <label aria-label="誌面＋EC" 
                                data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo5" #txta_TextInfo5
                              [width]="'calc(100% - 63px)'" [counterWidth]="'60px'" [subid]="'txta_TextInfo5'" [maxChars]="200"
                              forcedEnabledMode="true" [allowMultiLine]="false" [tabindex]="0" [height]="90"
                              [(ngModel)]="kymw1100Model.textInfo5" (blur)="eventTextInfo_FOCUSOUTHandler($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>便利情報(その他)</label>
                              <label aria-label="誌面＋EC" 
                                data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo6" #txta_TextInfo6
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo6'" [maxChars]="200" forcedEnabledMode="true"
                              [allowMultiLine]="false" [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo6"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" [height]="90">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>便利情報(eフレンズ)</label>
                              <label aria-label="EC" 
                                data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_EFriends" #lbl_Explain_EFriends>{{kymw00Model.EXPLAIN_E_FRIENDS}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo7" #txta_TextInfo7
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo7'" [maxChars]="200" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo7" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>便利情報(サイズ他)</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="layout_balance checkbox_btn_beside">
                              <div class="label_checkbox element-row">
                                <label id="lbl_Cnt_TextInfo8" #lbl_Cnt_TextInfo8>{{kymw1100Model.textInfoCnt8}}</label>
                                <label id="lbl_Explain_Size" #lbl_Explain_Size>{{kymw00Model.EXPLAIN_SIZE}}</label>
                              </div>
                              <button class="btn-secondary" id="lnb_TextInfo8" #lnb_TextInfo8 forcedEnabledMode="none"
                                [tabindex]="0" (click)="eventTextInfo_CLICKHandler($event)">候補を表示</button>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [disabled]="true" [restrict]="'[ -￮]'" id="txta_TextInfo8" #txta_TextInfo8
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo8'" [maxChars]="200" forcedEnabledMode="false"
                              [fullOnly]="true" [allowMultiLine]="false" [tabindex]="-1" [(ngModel)]="kymw1100Model.textInfo8"
                              [height]="90">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>取扱注意</label>
                              <label aria-label="誌面＋EC" 
                                data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="layout_balance checkbox_btn_beside">
                              <div class="label_checkbox">
                                <label id="lbl_Cnt_TextInfo9" #lbl_Cnt_TextInfo9>{{kymw1100Model.textInfoCnt9}}</label>
                              </div>
                              <button class="btn-secondary" id="lnb_TextInfo9" #lnb_TextInfo9 forcedEnabledMode="none"
                                [tabindex]="0" (click)="eventTextInfo_CLICKHandler($event)"
                                (keydown)="nextFocus($event)">候補を表示</button>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [disabled]="true" [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo9"
                              [counterWidth]="'60px'" #txta_TextInfo9 [subid]="'txta_TextInfo9'" [maxChars]="200"
                              forcedEnabledMode="false" [allowMultiLine]="false" [tabindex]="-1" [height]="90"
                              [(ngModel)]="kymw1100Model.textInfo9">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>EC用商品説明</label>
                              <label aria-label="EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_EC" #lbl_Explain_EC>{{kymw00Model.EXPLAIN_EC_GOODS}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo10" #txta_TextInfo10
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo10'" [maxChars]="200" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo10" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>月齢情報</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_MonthOld" #lbl_Explain_MonthOld>{{kymw00Model.EXPLAIN_MONTH_OLD}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo11" #txta_TextInfo11
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo11'" [maxChars]="200" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo11" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>健康管理情報</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_HealthManage" #lbl_Explain_HealthManage>{{kymw00Model.EXPLAIN_HEALTH_MANAGE}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo12" #txta_TextInfo12
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo12'" [maxChars]="200" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo12" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>成分情報</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_Ingredients" #lbl_Explain_Ingredients>{{kymw00Model.EXPLAIN_INGREDIENTS}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo13" #txta_TextInfo13
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo13'" [maxChars]="2000" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo13" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>吸水量</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_WaterAbsorption" #lbl_Explain_WaterAbsorption>{{kymw00Model.EXPLAIN_WATER_ABSORPTION}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo14" #txta_TextInfo14
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo14'" [maxChars]="200" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo14" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>調理時間の目安</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_CookingTime" #lbl_Explain_CookingTime>{{kymw00Model.EXPLAIN_COOKING_TIME}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo15" #txta_TextInfo15
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo15'" [maxChars]="200" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo15" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>○人前情報</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_Servings" #lbl_Explain_Servings>{{kymw00Model.EXPLAIN_SERVINGS}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo16" #txta_TextInfo16
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo16'" [maxChars]="200" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo16" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>材料</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_Material" #lbl_Explain_Material>{{kymw00Model.EXPLAIN_MATERIAL}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo17" #txta_TextInfo17
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo17'" [maxChars]="200" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo17" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>ご家庭で用意いただくもの</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_Preparatio" #lbl_Explain_Preparation>{{kymw00Model.EXPLAIN_PREPARATION}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo18" #txta_TextInfo18
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo18'" [maxChars]="200" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo18" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                        <div class="label_input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>人気商品情報</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="label_checkbox">
                              <label id="lbl_Explain_Popular" #lbl_Explain_EC>{{kymw00Model.EXPLAIN_POPULAR_GOODS}}</label>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [fullOnly]="true" id="txta_TextInfo19" #txta_TextInfo19
                              [counterWidth]="'60px'" [subid]="'txta_TextInfo19'" [maxChars]="200" forcedEnabledMode="true"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.textInfo19" [height]="90"
                              (blur)="eventTextInfo_FOCUSOUTHandler($event)" (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
  
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_DivInfoTab>発注・業態</a>
                    <div id="cnv_DivInfoTab" #cnv_DivInfoTab>
                      <div class="column-list">
                        <label class="list-input-title">臭い商品区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct110'" [labelField]="'codeValueName'" id="cmb_StinkGoodsDivList"
                            #cmb_StinkGoodsDivList [subid]="'cmb_StinkGoodsDivList'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [blank]="false" [(ngModel)]="kymw1100Model.stinkGoodsDivList">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">セット区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct144'" [labelField]="'codeValueName'" id="cmb_SetDivList"
                            #cmb_SetDivList [subid]="'cmb_SetDivList'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [required]="true" [(ngModel)]="kymw1100Model.setDivList">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">ケース供給区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct065'" [labelField]="'codeValueName'" id="cmb_CaseSupplyDivList"
                            #cmb_CaseSupplyDivList [subid]="'cmb_CaseSupplyDivList'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [blank]="false" [(ngModel)]="kymw1100Model.caseSupplyDivList">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">長期保存区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct102'" [labelField]="'codeValueName'" id="cmb_LongKeepDivList"
                            #cmb_LongKeepDivList [subid]="'cmb_LongKeepDivList'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [blank]="false" [(ngModel)]="kymw1100Model.longKeepDivList">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">仕分温度帯</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct316'" [labelField]="'codeValueName'" id="cmb_AssortTempdivList"
                            #cmb_AssortTempdivList [subid]="'cmb_AssortTempdivList'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [required]="true" [(ngModel)]="kymw1100Model.assortTempdivList"
                            (change)="eventAssortTempdivListHandler()">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">入荷場所区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct212'" [labelField]="'codeValueName'" id="cmb_ArrivalAreaDivList"
                            #cmb_ArrivalAreaDivList [subid]="'cmb_ArrivalAreaDivList'" [forcedEnabledMode]="'true'"
                            [tabindex]="0" [required]="true" [(ngModel)]="kymw1100Model.arrivalAreaDivList">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">入荷許可品温</label>
                        <div class="list-input-content">
                          <input type="text" id="txti_ArrivalGoodsTemp" #txti_ArrivalGoodsTemp forcedEnabledMode="true"
                            [tabindex]="0" plessInputTextSub [restrict]="'[\-0-9]'" [maxlength]="3"
                            [(ngModel)]="kymw1100Model.arrivalGoodsTemp" [style.width.rem]="4">
                        </div>
  
                        <label class="list-input-title">入荷管理日数</label>
                        <div class="list-input-content">
                          <input type="text" id="txti_ArrivalAdminDays" #txti_ArrivalAdminDays forcedEnabledMode="true"
                            [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3"
                            [(ngModel)]="kymw1100Model.arrivalAdminDays" [style.width.rem]="4">
                        </div>
  
                        <label class="list-input-title">業態区分(デイリー)</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ctp123'" [labelField]="'codeValueName'"
                            id="cmb_DutiesFormDailyDivList" #cmb_DutiesFormDailyDivList [subid]="'cmb_DutiesFormDailyDivList'"
                            [forcedEnabledMode]="'true'" [tabindex]="0" [blank]="false"
                            [(ngModel)]="kymw1100Model.dutiesFormDailyDivList">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">割れ物フラグ</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct418'" [labelField]="'codeValueName'" id="cmb_FragileFlgList"
                            #cmb_FragileFlgList [subid]="'cmb_FragileFlgList'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [blank]="false" [(ngModel)]="kymw1100Model.fragileFlgList" (keydown)="nextFocus($event)">
                          </app-code-combo-box>
                        </div>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_GoodsListingTab>表組情報</a>
                    <div id="cnv_GoodsListingTab" #cnv_GoodsListingTab class="element-column">
                      <div class="column-list">
                        <div class="list-input-title layout_balance">
                          <label>表組用商品名</label>
                          <label aria-label="誌面" data-microtip-position="bottom" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                        <div class="list-input-content">
                          <app-text-input [restrict]="'[ -￮]'" [fullOnly]="true" id="txti_ListingGoodsName"
                            #txti_ListingGoodsName [subid]="'txti_ListingGoodsName'" [maxChars]="30"
                            [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw1100Model.listingGoodsName" [style.width.rem]="36" >
                          </app-text-input>
                        </div>
                      </div>
                      <div>
                        <div class="column-list">
                          <label class="list-input-title">表組項目一覧</label>
                          <div class="grid-container" [style.height.px]="!dispDialog ? 292: 273">
                            <wj-flex-grid #dtg_ListingList id="dtg_ListingList" forcedEnabledMode="true" [tabindex]="0" [style.width.px]="708"
                              [allowSorting]="false" [allowDragging]="'None'" rowHeight="25"
                              [itemsSource]="kymw1100Model.listingList" [isReadOnly]="true" [headersVisibility]="'Column'"
                              (keydown)="nextFocus($event)">
                              <wj-flex-grid-column [minWidth]="5" [width]="180" [binding]="'ListingItemName'" [header]="'項目名'">
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="511" [binding]="'DispContents'" [header]="'表示内容'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <app-text-input [fullOnly]="true" [restrict]="'[ -￮]'" [displayCountField]="false"
                                    [maxChars]="25" [(ngModel)]="cell.item.DispContents"
                                    (change)="eventEditHandler()"></app-text-input>
                                </ng-template>
                              </wj-flex-grid-column>
                            </wj-flex-grid>
                          </div>
                        </div>
                        <div>
                          <label [style.color]="'#E41F1F'">EC連携：</label>
                          <label [style.color]="'#212529'">表組</label>
                          <label [style.color]="'#E41F1F'">「適用体重」「パンツ・テープ」</label>
                          <label [style.color]="'#212529'">は、部門="07:住関連" かつ 小分類="620601:おむつ" の場合に連携される</label>
                        </div>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_DnaInfoTab>商品DNA</a>
                    <div id="cnv_DnaInfoTab" #cnv_DnaInfoTab>
                      <div class="grid-container" [style.height.px]="!dispDialog ? 350: 331">
                        <wj-flex-grid #dtg_DnaInfoList id="dtg_DnaInfoList" [allowDragging]="'None'" forcedEnabledMode="true"
                          [tabindex]="0" [allowSorting]="false" rowHeight="25" [style.width.px]="812" horizontalGridLines="true"
                          [itemsSource]="kymw1100Model.dnaList" [isReadOnly]="true" [headersVisibility]="'Column'"
                          (keydown)="nextFocus($event)" class="always-scrollbars">
                          <wj-flex-grid-column [minWidth]="5" [width]="60" [align]="'center'" [binding]="'Check'"
                            [header]="'設定'" [isReadOnly]="true">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                              <input type="checkbox" [(ngModel)]="cell.item.Check" (change)="eventEditHandler()"
                                id="cb_dna_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                            </ng-template>
                          </wj-flex-grid-column>
                          <wj-flex-grid-column [minWidth]="5" [width]="733" [binding]="'DnaName'" [header]="'DNA名称'">
                          </wj-flex-grid-column>
                        </wj-flex-grid>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_HealthPromotionTab>保健機能</a>
                    <div id="cnv_HealthPromotionTab" #cnv_HealthPromotionTab>
                      <div class="element-column">
                        <div class="column-list">
                          <div class="list-input-title layout_balance">
                            <label>届出番号</label>
                            <label aria-label="EC" data-microtip-position="bottom" role="tooltip" class="question">
                              <fa-icon [icon]="iconQuestion"></fa-icon></label>
                          </div>
                          <div class="list-input-content">
                            <app-text-input [restrict]="'[ -￮]'" id="txti_LicencedNo" #txti_LicencedNo
                              [subid]="'txti_LicencedNo'" [fullOnly]="true" [maxChars]="10" [forcedEnabledMode]="'true'"
                              [tabindex]="0" [width]="'150px'" [(ngModel)]="kymw1100Model.licencedNo">
                            </app-text-input>
                          </div>
                        </div>
                        <div class="input_vertical">
                          <div class="list-title_checkbox_beside">
                            <div class="list-input-title layout_balance">
                              <label>届出表示･許可表示</label>
                              <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                                <fa-icon [icon]="iconQuestion"></fa-icon></label>
                            </div>
                            <div class="layout_balance checkbox_btn_beside">
                              <div class="label_checkbox">
                                <label id="lbl_Cnt_LicencedDescription">{{kymw1100Model.licencedDescriptionCnt}}</label>
                              </div>
                              <button class="btn-secondary " id="lnb_LicencedDescription" #lnb_LicencedDescription
                                forcedEnabledMode="none" [tabindex]="0"
                                (click)="eventTextInfo_CLICKHandler($event)">候補を表示</button>
                            </div>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [disabled]="true" [restrict]="'[ -￮]'" [allowMultiLine]="false" [fullOnly]="true"
                              [maxChars]="400" id="txta_LicencedDescription" #txta_LicencedDescription
                              [subid]="'txta_LicencedDescription'" [forcedEnabledMode]="'true'" [tabindex]="-1"
                              [counterWidth]="'60px'" [(ngModel)]="kymw1100Model.licencedDescription" [height]="90">
                            </app-text-area>
                          </div>
                        </div>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_TagInfoTab>タグ情報</a>
                    <div class="element-column">
                      <div class="element-row" style="align-items: center;">
                        <button id="btn_TagSelect" #btn_Seach [tabindex]="0" class="btn-secondary" forcedEnabledMode="true"
                          (click)="eventTagSelect_CLICKHandler()">タグ選択</button>
                      </div>
                      <div class="column-list">
                        <label class="list-input-title">タグ一覧</label>
                        <div class="grid-container" [style.height.px]="!dispDialog ? 312: 293"> 
                          <wj-flex-grid #dtg_Tag id="dtg_Tag" [tabindex]="0" [isReadOnly]="true" [style.width.px]="745"
                            [itemsSource]="kymw1100Model.tagInfo" [headersVisibility]="'Column'" class="always-scrollbars">
                            <wj-flex-grid-column [minWidth]="5" [width]="340" [binding]="'TagGroupName'" [header]="'タググループ名'">
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [minWidth]="5" [width]="388" [binding]="'TagName'" [header]="'タグ名'">
                            </wj-flex-grid-column>
                          </wj-flex-grid>
                        </div>
                      </div>
                    </div>
                  </wj-tab>
        
                  <wj-tab>
                    <a #a_PageInfoTab>関連ページ</a>
                    <div id="cnv_PageInfoTab" #cnv_PageInfoTab>
                      <div class="element-column">
                        <div class="column-list">
                          <div class="list-input-title" style="width: 120px;">
                            <label>コープ商品タイトル</label>
                          </div>
                          <div class="list-input-content">
                            <app-text-input [disabled]="true" id="txti_CoopGoodsTitle" #txti_CoopGoodsTitle
                              [subid]="'txti_CoopGoodsTitle'" [maxChars]="50" [forcedEnabledMode]="'true'"
                              [tabindex]="0" [width]="'626px'" [(ngModel)]="kymw1100Model.coopGoodsTitle" [counterWidth]="'40px'">
                            </app-text-input>
                          </div>
                        </div>
                        <div class="input_vertical">
                          <div class="list-input-title">
                            <label>コープ商品URL</label>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [disabled]="true" [allowMultiLine]="true"
                              [maxChars]="255" id="txta_CoopGoodsUrl" #txta_CoopGoodsUrl
                              [subid]="'txta_CoopGoodsUrl'" [forcedEnabledMode]="'true'" [tabindex]="-1"
                              [counterWidth]="'60px'" [(ngModel)]="kymw1100Model.coopGoodsUrl" [height]="100">
                            </app-text-area>
                          </div>
                        </div>
                        <div class="column-list">
                          <div class="list-input-title" style="width: 120px;">
                            <label>関連情報タイトル</label>
                          </div>
                          <div class="list-input-content">
                            <app-text-input [restrict]="'[ -￮]'" id="txti_PageTitle" #txti_PageTitle
                              [subid]="'txti_PageTitle'" [fullOnly]="true" [maxChars]="50" [forcedEnabledMode]="'true'"
                              [tabindex]="0" [width]="'626px'" [(ngModel)]="kymw1100Model.pageTitle" [counterWidth]="'40px'">
                            </app-text-input>
                          </div>
                        </div>
                        <div class="input_vertical">
                          <div class="list-input-title">
                            <label>関連情報URL</label>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[a-zA-Z0-9@!#&amp;$%\'*+\-/=?\^_`\{\|\}~.()<>:;&quot;\\[\\]\\\\]'"
                              [allowMultiLine]="false" [halfOnly]="true" [maxChars]="255" id="txta_PageUrl" #txta_PageUrl
                              [subid]="'txta_PageUrl'" [forcedEnabledMode]="'true'" [tabindex]="-1"
                              [counterWidth]="'60px'" [(ngModel)]="kymw1100Model.pageUrl" [height]="100"
                              (input)="eventPageUrl_deleteCommaHandler()"
                              (compositionstart)="onCompStart()" (compositionend)="onCompDeleteCommaEnd($event)">
                            </app-text-area>
                          </div>
                        </div>
                      </div>
                    </div>
                  </wj-tab>
                </div>
              </wj-tab-panel>
            </div>
  
            <div id="cnv_info2" class="block-column" [class.div-disabled-style]="!kymw1100Model.enabledInfo2Flg">
              <div>
                <h1>アイテム情報編集</h1>
                <div class="element-column">
                  <div class="block-row">
                    <div class="column-list">
                      <label class="list-input-title">登録日</label>
                      <div class="list-input-content">
                        <input type="text" id="lbl_RegistDate" #lbl_RegistDate style="width: 15rem;" value="{{kymw1100Model.registDate}}" readonly>
                      </div>
                    </div>
                    <div class="column-list">
                      <label class="list-input-title">更新日</label>
                      <div class="list-input-content">
                        <input type="text" forcedEnabledMode="true" id="lbl_UpdateDate" #lbl_UpdateDate
                          style="width: 15rem;" value="{{kymw1100Model.updateDate}}" readonly>
                      </div>
                    </div>
                  </div>
                  <div class="block-row">
                    <div class="column-list">
                      <label class="list-input-title">アイテムコード</label>
                      <div class="list-input-content">
                        <select id="cmb_ItemCode" #cmb_ItemCode [tabindex]="0" [(ngModel)]="kymw1100Model.itemCode"
                          (change)="eventItemCode_CHANGEHandler($event)" style="width: 7rem;">
                          <ng-template ngFor let-item [ngForOf]="kymw1100Model.itemList">
                            <option value="{{item.ItemCode}}">{{item['ItemCode']}}</option>
                          </ng-template>
                        </select>
                        <app-clipboard-copy-icon [tabindex]="0" [forcedEnabledMode]="'true'" [tooltip]="'アイテムコードをコピー'"
                          value="{{kymw1100Model.itemCode}}"></app-clipboard-copy-icon>
                      </div>
                    </div>
                    <div class="element-row buttons">
                      <button id="btn_StatusDelete" class="btn-tartiary warning" #btn_StatusDelete forcedEnabledMode="none"
                        [tabindex]="0" [disabled]="true" (click)="eventStatusDelete_CLICKHandler()">アイテム情報を削除</button>
                      <button [disabled]="true" id="btn_ItemCopy" class="btn-secondary" #btn_ItemCopy forcedEnabledMode="none"
                        [tabindex]="0" (click)="eventItemCopy_CLICKHandler()">アイテム情報をコピー</button>
                      <button [disabled]="true" id="btn_GoodsItem" class="btn-secondary" #btn_GoodsItem forcedEnabledMode="none"
                        [tabindex]="0" (click)="eventGoodsItemNew_CLICKHandler()">アイテム情報を新規作成</button>
                    </div>
                  </div>
                  <div class="block-row">
                    <div class="column-list">
                      <label class="list-input-title">JANコード</label>
                      <div class="list-input-content">
                        <input type="text" class="text-label-required jan-code" id="txti_JanCode" #txti_JanCode [maxlength]="13"
                          plessInputTextSub [restrict]="'[0-9]'" forcedEnabledMode="true" [tabindex]="0"
                          [(ngModel)]="kymw1100Model.janCode"/>
                        <label style="margin: 0;">
                          <input type="checkbox" id="chk_JanCodeDiv" #chk_JanCodeDiv forcedEnabledMode="true" [tabindex]="0"
                            [(ngModel)]="kymw1100Model.janCodeDiv" (change)="eventJanCodeDiv_CLICKHandler()"/>
                          <span>8桁</span>
                        </label>
                      </div>
                    </div>
                    <div class="element-row">
                      <button id="btn_Install" #btn_Install class="btn-secondary" forcedEnabledMode="none" [tabindex]="0"
                        (click)="eventInstall_CLICKHandler()">インストア採番</button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- タブ領域 -->
              <wj-tab-panel id="tab_item" #tab_item
                (selectedTabChange)="selectedTabItemChange()">
                <div>
                  <wj-tab>
                    <a #a_itemTab>アイテム</a>
                    <div id="cnv_itemTab" #cnv_itemTab>
                      <div class="column-list">
                        <label class="list-input-title">ブランド区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct314'" [labelField]="'codeValueName'" id="cmb_BrandType"
                            #cmb_BrandType [subid]="'cmb_BrandType'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [required]="true" [(ngModel)]="kymw1100Model.brandTypeList">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">FC・MC手数料</label>
                        <div class="list-input-content">
                          <input type="text" id="txti_FcmcFee" #txti_FcmcFee forcedEnabledMode="true" [tabindex]="0"
                            plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="8" [(ngModel)]="kymw1100Model.fcmcFee" [style.width.rem]="7">
                        </div>
  
                        <label class="list-input-title">特殊発注区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct216'" [labelField]="'codeValueName'" id="cmb_SpecialOrderTypeList"
                            #cmb_SpecialOrderTypeList [subid]="'cmb_SpecialOrderTypeList'" [forcedEnabledMode]="'true'"
                            [tabindex]="0" [blank]="false" [(ngModel)]="kymw1100Model.specialOrderTypeList">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">在庫繰越区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct115'" [labelField]="'codeValueName'" id="cmb_StockTypeList"
                            #cmb_StockTypeList [subid]="'cmb_StockTypeList'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [blank]="false" [(ngModel)]="kymw1100Model.stockTypeList">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">分納指定回数</label>
                        <div class="list-input-content">
                          <input type="text" id="txti_InstallmentTimes" #txti_InstallmentTimes forcedEnabledMode="true"
                            [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="1"
                            [(ngModel)]="kymw1100Model.installmentTimes" [style.width.rem]="4">
                        </div>
  
                        <label class="list-input-title">物流滞留日数</label>
                        <div class="list-input-content">
                          <input type="text" id="txti_PdPilingUpDays" #txti_PdPilingUpDays forcedEnabledMode="true"
                            [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="3"
                            [(ngModel)]="kymw1100Model.pdPilingUpDays" [style.width.rem]="4">
                        </div>
  
                        <label class="list-input-title">ITFコード</label>
                        <div class="list-input-content" style="width: 11rem;">
                          <input type="text" id="txti_ItfCode" #txti_ItfCode forcedEnabledMode="true" [tabindex]="0"
                            plessInputTextSub [restrict]="'[0-9]'" [maxlength]="16" [(ngModel)]="kymw1100Model.itfCode">
                        </div>
  
                        <label class="list-input-title">発注単位区分</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct026'" [labelField]="'codeValueName'" id="cmb_OrderUnitType"
                            #cmb_OrderUnitType [subid]="'cmb_OrderUnitType'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [blank]="false" [required]="true" [(ngModel)]="kymw1100Model.orderUnitType">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title">メーカー希望小売価格(参考)</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct291'" [labelField]="'codeValueName'" id="cmb_PriceType"
                            #cmb_PriceType [subid]="'cmb_PriceType'" [forcedEnabledMode]="'true'" [tabindex]="0"
                            [(ngModel)]="kymw1100Model.priceType">
                          </app-code-combo-box>
                          <input type="text" id="txti_MakerPrice" #txti_MakerPrice forcedEnabledMode="true" [tabindex]="0"
                            plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" [(ngModel)]="kymw1100Model.makerPrice" [style.width.rem]="7">
                        </div>
  
                        <label class="list-input-title">発注先取引先</label>
                        <div class="list-input-content">
                          <input type="text" class="text-label-required" id="txti_OrderClientCode" #txti_OrderClientCode
                            forcedEnabledMode="true" [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6"
                            [(ngModel)]="kymw1100Model.orderClientCode" (blur)="eventOrderClient_FOCUSOUTHandler()" style="width:7rem;">
                          <button id="btn_OrderClient" #btn_OrderClient forcedEnabledMode="none" [tabindex]="0"
                            class="btn-secondary" (click)="eventOrderClient_CLICKHandler($event)">検索</button>
                          <input type="text" id="txti_OrderClientName" #txti_OrderClientName plessInputTextSub
                            [restrict]="'[ -￮]'" [(ngModel)]="kymw1100Model.orderClientName" readonly>
                        </div>
  
                        <label class="list-input-title">支払先取引先</label>
                        <div class="list-input-content">
                          <input type="text" class="text-label-required" id="txti_PayeeClientCode" #txti_PayeeClientCode
                            forcedEnabledMode="true" [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6"
                            [(ngModel)]="kymw1100Model.payeeClientCode" (blur)="eventPayeeClient__FOCUSOUTHandler()" style="width:7rem;">
                          <button id="btn_PayeeClient" #btn_PayeeClient forcedEnabledMode="none" [tabindex]="0"
                            class="btn-secondary" (click)="eventOrderClient_CLICKHandler($event)">検索</button>
                          <input type="text" id="txti_PayeeClientName" #txti_PayeeClientName plessInputTextSub
                            [restrict]="'[ -￮]'" [(ngModel)]="kymw1100Model.payeeClientName" readonly>
                        </div>
  
                        <label class="list-input-title">確定入数</label>
                        <div class="list-input-content">
                          <input type="text" class="text-label-required" id="txti_FixContainNum" #txti_FixContainNum
                            forcedEnabledMode="true" [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="4"
                            [(ngModel)]="kymw1100Model.fixContainNum" [style.width.rem]="4">
                        </div>
  
                        <label class="list-input-title">組数</label>
                        <div class="list-input-content">
                          <input type="text" class="text-label-required" id="txti_SetQuantity" #txti_SetQuantity
                            forcedEnabledMode="true" [tabindex]="0" plessInputTextSub [restrict]="'[0-9]'" [maxlength]="1"
                            [(ngModel)]="kymw1100Model.setQuantity" (keydown)="nextFocus($event)" [style.width.rem]="4">
                        </div>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_CoopInfoTab>利用生協</a>
                    <div id="cnv_CoopInfoTab" #cnv_CoopInfoTab>
                      <div class="block-column">
                        <div>
                          <h2>設定値一括反映</h2>
                          <div class="element-column">
                            <div class="block-row">
                              <div class="column-list">
                                <label class="list-input-title">供給価格(通常)</label>
                                <div class="list-input-content">
                                  <input type="text" id="txti_SupplyPriceCoefficient" #txti_SupplyPriceCoefficient
                                    plessInputTextSub [restrict]="'[0-9]'" [maxlength]="7" forcedEnabledMode="true"
                                    [tabindex]="0" [(ngModel)]="kymw1100Model.supplyPriceCoefficient"
                                    [style.width.rem]="7"/>
                                </div>
                                <label class="list-input-title">供給価格(特価１)</label>
                                <div class="list-input-content">
                                  <input type="text" id="txti_SupplyPriceSpecial1" #txti_SupplyPriceSpecial1 plessInputTextSub
                                    [restrict]="'[0-9]'" [maxlength]="7" forcedEnabledMode="true" [tabindex]="0"
                                    [(ngModel)]="kymw1100Model.supplyPriceSpecial1"
                                    [style.width.rem]="7"/>
                                </div>
                                <label class="list-input-title">供給価格(特価２)</label>
                                <div class="list-input-content">
                                  <input type="text" id="txti_SupplyPriceSpecial2" #txti_SupplyPriceSpecial2 plessInputTextSub
                                    [restrict]="'[0-9]'" [maxlength]="7" forcedEnabledMode="true" [tabindex]="0"
                                    [(ngModel)]="kymw1100Model.supplyPriceSpecial2"
                                    [style.width.rem]="7"/>
                                </div>
                              </div>
                              <div class="column-list">
                                <label class="list-input-title">単品仕入価格(通常)</label>
                                <div class="list-input-content">
                                  <input type="text" id="txti_CostPricecoefficient" #txti_CostPricecoefficient plessInputTextSub
                                    [restrict]="'[0-9\.]'" [maxlength]="10" forcedEnabledMode="true" [tabindex]="0"
                                    [(ngModel)]="kymw1100Model.costPricecoefficient"
                                    [style.width.rem]="7"/>
                                </div>
                                <label class="list-input-title">単品仕入価格(特価１)</label>
                                <div class="list-input-content">
                                  <input type="text" id="txti_CostPriceSpecial1" #txti_CostPriceSpecial1 plessInputTextSub
                                    [restrict]="'[0-9\.]'" [maxlength]="10" forcedEnabledMode="true" [tabindex]="0"
                                    [(ngModel)]="kymw1100Model.texi_costPriceSpecial1"
                                    [style.width.rem]="7"/>
                                </div>
                                <label class="list-input-title">単品仕入価格(特価２)</label>
                                <div class="list-input-content">
                                  <input type="text" id="txti_CostPriceSpecial2" #txti_CostPriceSpecial2 plessInputTextSub
                                    [restrict]="'[0-9\.]'" [maxlength]="10" forcedEnabledMode="true" [tabindex]="0"
                                    [(ngModel)]="kymw1100Model.texi_costPriceSpecial2"
                                    [style.width.rem]="7"/>
                                </div>
                              </div>
                            </div>
                            <div class="column-list">
                              <label class="list-input-title" style="width: 126px;">価格バンドル</label>
                              <div class="list-input-content">
                                <input type="text" class="text-label-required" id="txti_BundlePrice" #txti_BundlePrice
                                  plessInputTextSub [restrict]="'[0-9]'" [maxlength]="2" forcedEnabledMode="true" [tabindex]="0"
                                  [(ngModel)]="kymw1100Model.bundlePrice" (blur)="eventBundlePrice_ChangeHandler(null)"
                                  (keydown)="nextFocus($event)" [style.width.rem]="4" />
                              </div>
                            </div>
                            <button id="btn_SupplyPrice" #btn_SupplyPrice class="btn-secondary" forcedEnabledMode="none"
                              [tabindex]="0" (click)="eventSupplyPrice_CLICKHandler()"
                              (keydown)="nextFocus($event)">一括反映</button>
                          </div>
                        </div>
                        <!-- データグリッド領域(利用生協) -->
                        <div>
                          <div class="action-area">
                            <div class="column-list">
                              <label class="list-input-title">税込価格</label>
                              <div class="list-input-content">
                                <label>
                                  <input type="checkbox" id="chk_Zeikomi" #chk_Zeikomi forcedEnabledMode="true" [tabindex]="0"
                                    [(ngModel)]="kymw1100Model.zeikomi" (change)="eventZeikomi_CLICKHandler(null)" />
                                  <span>表示する</span>
                                </label>
                                <input type="text" id="txti_ConsumeMessage" #txti_ConsumeMessage forcedEnabledMode="true"
                                  style="width: 16rem;" disabled
                                  [(ngModel)]="kymw1100Model.consumeMessage" />
                              </div>
                            </div>
                          </div>
                          <div class="grid-container">
                            <wj-flex-grid #dtg_UseCoopInfoList id="dtg_UseCoopInfoList" [allowDragging]="'None'"
                              [allowSorting]="false" lockedColumnCount="2" horizontalScrollPolicy="on" [tabindex]="0"
                              [itemsSource]="kymw1100Model.coopInfoListScreen" [isReadOnly]="true" [headersVisibility]="'Column'"
                              [frozenColumns]="2" [style.height.px]="323">
                              <wj-flex-grid-column [minWidth]="5" [width]="60" [align]="'left'" [allowResizing]="true"
                                [binding]="'CoopShortName'" [header]="'生協'">
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="60" [align]="'center'" [allowResizing]="true"
                                [binding]="'Check'" [header]="'設定'" [isReadOnly]="true">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="checkbox" [disabled]="cell.item.Check && (cell.item.Enabled === '2')"
                                    [(ngModel)]="cell.item.Check" (change)="checkBoxMouseClick(cell.item);eventEditHandler()"
                                    id="cb_use_coop_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div class="all-coop-setting-checkbox">
                                    設定<br>
                                    <input type="checkbox" id="chk_AllCoop" #chk_AllCoop forcedEnabledMode="true" [tabindex]="0"
                                      [disabled]="kymw1100Model.allCoopIsDisable"
                                      (change)="eventAllCoop_CLICKHandler(null)" [(ngModel)]="kymw1100Model.allCoop"
                                      class="all-coop-setting-checkbox headear-checkbox" />
                                  </div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="80" [binding]="'SupplyPriceStandard'"
                                [header]="coopHeaderPreText + '供給\n通常'" [multiLine]="true" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" [style.text-align]="'right'" [style.width.%]="100" autocomplete="off"
                                    [disabled]="!cell.item.Check" plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="7"
                                    [(ngModel)]="cell.item.SupplyPriceStandard"
                                    (blur)="eventEditHandlerCoopInfoList(dtg_UseCoopInfoList.selection.row, cell.col.binding, cell.item.SupplyPriceStandard)"
                                    (change)="eventEditHandler()">
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="coopHeaderPreText + '供給価格(通常)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="80" [align]="'right'" [binding]="'SupplyTaxWithStd'"
                                [header]="coopHeaderPreText + '供給\n通常税込'" [multiLine]="true" [visible]="false">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <div [style.text-align]="'right'">{{ cell.item.SupplyTaxWithStd }}</div>
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="coopHeaderPreText + '供給価格(通常)(税込)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="80" [binding]="'SupplyPriceSpecial1'"
                                [header]="coopHeaderPreText + '供給\n特１'" [multiLine]="true" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" [style.text-align]="'right'" [style.width.%]="100" autocomplete="off"
                                    [disabled]="!cell.item.Check" plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="7"
                                    [(ngModel)]="cell.item.SupplyPriceSpecial1"
                                    (blur)="eventEditHandlerCoopInfoList(dtg_UseCoopInfoList.selection.row, cell.col.binding, cell.item.SupplyPriceSpecial1)"
                                    (change)="eventEditHandler()">
  
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="coopHeaderPreText + '供給価格(特価１)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="80" [align]="'right'" [binding]="'SupplyTaxWithSpc1'"
                                [header]="coopHeaderPreText + '供給\n特1税込'" [multiLine]="true" [visible]="false">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <div [style.text-align]="'right'">{{ cell.item.SupplyTaxWithSpc1 }}</div>
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="coopHeaderPreText + '供給価格(特価１)(税込)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="80" [binding]="'SupplyPriceSpecial2'"
                                [header]="coopHeaderPreText + '供給\n特２'" [multiLine]="true" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" [style.text-align]="'right'" [style.width.%]="100" autocomplete="off"
                                    [disabled]="!cell.item.Check" plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="7"
                                    [(ngModel)]="cell.item.SupplyPriceSpecial2"
                                    (blur)="eventEditHandlerCoopInfoList(dtg_UseCoopInfoList.selection.row, cell.col.binding, cell.item.SupplyPriceSpecial2)"
                                    (change)="eventEditHandler()">
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="coopHeaderPreText + '供給価格(特価２)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="80" [align]="'right'" [binding]="'SupplyTaxWithSpc2'"
                                [header]="coopHeaderPreText + '供給\n特2税込'" [multiLine]="true" [visible]="false">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <div [style.text-align]="'right'">{{ cell.item.SupplyTaxWithSpc2 }}</div>
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="coopHeaderPreText + '供給価格(特価2)(税込)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="105" [binding]="'CostPriceStandard'"
                                [header]="'単仕入\n通常'" [multiLine]="true" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" [style.text-align]="'right'" [style.width.%]="100" autocomplete="off"
                                    [disabled]="!cell.item.Check" plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="10"
                                    [(ngModel)]="cell.item.CostPriceStandard"
                                    (blur)="kymw1100Model.updateConsignPriceStandard(kymw1100Model.coopInfoListScreen, cell.item)"
                                    (change)="eventEditHandler()">
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="'単品仕入価格(通常)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="105" [binding]="'CostPriceSpecial1'"
                                [header]="'単仕入\n特１'" [multiLine]="true" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" [style.text-align]="'right'" [style.width.%]="100" autocomplete="off"
                                    [disabled]="!cell.item.Check" plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="10"
                                    [(ngModel)]="cell.item.CostPriceSpecial1"
                                    (blur)="kymw1100Model.updateConsignPriceStandard(kymw1100Model.coopInfoListScreen, cell.item)"
                                    (change)="eventEditHandler()">
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="'単品仕入価格(特価１)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
  
                              <wj-flex-grid-column [minWidth]="5" [width]="105" [binding]="'CostPriceSpecial2'"
                                [header]="'単仕入\n特２'" [multiLine]="true" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="text" [style.text-align]="'right'" [style.width.%]="100" autocomplete="off"
                                    [disabled]="!cell.item.Check" plessInputTextSub [restrict]="'[0-9\.]'" [maxlength]="10"
                                    [(ngModel)]="cell.item.CostPriceSpecial2"
                                    (blur)="kymw1100Model.updateConsignPriceStandard(kymw1100Model.coopInfoListScreen, cell.item)"
                                    (change)="eventEditHandler()">
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="'単品仕入価格(特価２)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="105" [binding]="'ConsignPriceStandard'"
                                [header]="'仕入価\n通常'" [multiLine]="true" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <div [style.text-align]="'right'">{{ cell.item.ConsignPriceStandard | number:'1.2-2' | deleteComma}}</div>
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="'仕入価格(通常)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="105" [binding]="'ConsignPriceSpecial1'"
                                [header]="'仕入価\n特１'" [multiLine]="true" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <div [style.text-align]="'right'">{{ cell.item.ConsignPriceSpecial1 | number:'1.2-2' | deleteComma}}</div>
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="'仕入価格(特価１)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="105" [binding]="'ConsignPriceSpecial2'"
                                [header]="'仕入価\n特２'" [multiLine]="true" [align]="'right'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <div [style.text-align]="'right'">{{ cell.item.ConsignPriceSpecial2 | number:'1.2-2' | deleteComma}}</div>
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div [wjTooltip]="'仕入価格(特価２)'">{{ cell.col.header }}</div>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="250" [binding]="'ProducingAreaComment1'"
                                [header]="'産地コメント１'" [align]="'lefh'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div class="layout_balance">
                                    <span>産地コメント１</span>
                                    <label aria-label="誌面＋EC" data-microtip-position="left" role="tooltip" class="question">
                                      <fa-icon [icon]="iconQuestion"></fa-icon></label>
                                  </div>
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <app-text-input [restrict]="'[ -￮]'" [maxChars]="50" [fullOnly]="true"
                                    [(ngModel)]="cell.item.ProducingAreaComment1" [displayCountField]="false"
                                    [disabled]="!cell.item.Check || !cell.item.ClassCode" (change)="eventEditHandler()">
                                  </app-text-input>
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="250" [binding]="'ProducingAreaComment2'"
                                [header]="'産地コメント２'" [align]="'left'">
                                <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'" let-cell="cell">
                                  <div class="layout_balance">
                                    <span>産地コメント２</span>
                                    <label aria-label="誌面＋EC" data-microtip-position="left" role="tooltip" class="question">
                                      <fa-icon [icon]="iconQuestion"></fa-icon></label>
                                  </div>
                                </ng-template>
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <app-text-input [restrict]="'[ -￮]'" [maxChars]="50" [fullOnly]="true"
                                    [(ngModel)]="cell.item.ProducingAreaComment2" [displayCountField]="false"
                                    [disabled]="!cell.item.Check || !cell.item.ClassCode" (change)="eventEditHandler()">
                                  </app-text-input>
                                </ng-template>
                              </wj-flex-grid-column>
                            </wj-flex-grid>
                          </div>
                        </div>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_Spec1Tab>仕様書１</a>
                    <div id="cnv_Spec1Tab" #cnv_Spec1Tab>
                      <div class="element-column">
                        <div class="column-list">
                          <label class="list-input-title" style="width: 174px;">訂正元eBASE NO</label>
                          <div class="list-input-content">
                            <input type="text" id="txti_EbaseSpecCode" #txti_EbaseSpecCode
                              plessInputTextSub [restrict]="'[ -￮]'" class="e-base-no"
                              [(ngModel)]="kymw1100Model.ebaseSpecCode" readonly/>
                          </div>
                        </div>
                        <div class="block-row">
                          <div class="column-list">
                            <label class="list-input-title" style="width: 174px;">仕様書適用日</label>
                            <div class="list-input-content">
                              <input type="text" id="dtf_SpecApplyDate" #dtf_SpecApplyDate
                                plessInputTextSub [restrict]="'[ -￮]'"
                                [(ngModel)]="kymw1100Model.specApplyDate" [style.width.rem]="15" readonly/>
                            </div>
                          </div>
                          <div class="column-list">
                            <label class="list-input-title" style="width: 174px;">登録時企画回</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_RegistCatalogRound" #txti_RegistCatalogRound plessInputTextSub
                                [restrict]="'[0-9]'" [maxlength]="8" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.registCatalogRound" [style.width.rem]="8" />
                            </div>
                          </div>
                        </div>
                        <div class="column-list">
                          <div class="list-input-title layout_balance" style="width: 174px;">
                            <label>メーカー名称</label>
                            <label aria-label="誌面＋EC：メーカー名称表示 &#10003;時のみ" data-microtip-position="top" role="tooltip" class="question">
                              <fa-icon [icon]="iconQuestion"></fa-icon></label>
                          </div>
                          <div class="list-input-content">
                            <app-text-input [restrict]="'[ -￮]'" [style.width.rem]="26" id="txti_MakerName" #txti_MakerName
                              [fullOnly]="true" [subid]="'txti_MakerName'" [maxChars]="20" [forcedEnabledMode]="'true'"
                              [tabindex]="0" [(ngModel)]="kymw1100Model.makerName">
                            </app-text-input>
                            <label>
                              <input type="checkbox" id="chk_MakerNamePublishType" #chk_MakerNamePublishType
                                forcedEnabledMode="true" [tabindex]="0" [(ngModel)]="kymw1100Model.makerNamePublishType" />
                              <span>メーカー名称表示</span>
                            </label>
                          </div>
                        </div>
                        <div class="block-row">
                          <div class="column-list" style="width: 388px;">
                            <label class="list-input-title" style="width: 174px;">ﾋﾟｰｽｻｲｽﾞ(縦)</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_PeaceSizeLength" #txti_PeaceSizeLength plessInputTextSub
                                [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.peaceSizeLength" [style.width.rem]="5"/>
                            </div>
                            <label class="list-input-title">ﾋﾟｰｽｻｲｽﾞ(横)</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_PeaceSizeWidth" #txti_PeaceSizeWidth plessInputTextSub
                                [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.peaceSizeWidth" [style.width.rem]="5"/>
                            </div>
                            <label class="list-input-title">ﾋﾟｰｽｻｲｽﾞ(高)</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_PeaceSizeHight" #txti_PeaceSizeHight plessInputTextSub
                                [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.peaceSizeHight" [style.width.rem]="5"/>
                            </div>
                            <label class="list-input-title">ﾋﾟｰｽ重量</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_PeaceWeight" #txti_PeaceWeight plessInputTextSub [restrict]="'[0-9]'"
                                [maxlength]="5" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.peaceSizeWeight" [style.width.rem]="5"/>
                            </div>
                          </div>
                          <div class="column-list">
                            <label class="list-input-title" style="width: 174px;">ｹｰｽｻｲｽﾞ(縦)</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_CaseSizeLength" #txti_CaseSizeLength plessInputTextSub
                                [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.caseSizeLength" [style.width.rem]="5"/>
                            </div>
                            <label class="list-input-title">ｹｰｽｻｲｽﾞ(横)</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_CaseSizeWidth" #txti_CaseSizeWidth plessInputTextSub
                                [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.caseSizeWidth" [style.width.rem]="5"/>
                            </div>
                            <label class="list-input-title">ｹｰｽｻｲｽﾞ(高)</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_CaseSizeHight" #txti_CaseSizeHight plessInputTextSub
                                [restrict]="'[0-9]'" [maxlength]="4" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.caseSizeHight" [style.width.rem]="5"/>
                            </div>
                            <label class="list-input-title">ｹｰｽ重量</label>
                            <div class="list-input-content">
                              <input type="text" id="txti_CaseWeight" #txti_CaseWeight plessInputTextSub [restrict]="'[0-9]'"
                                [maxlength]="5" forcedEnabledMode="true" [tabindex]="0"
                                [(ngModel)]="kymw1100Model.caseSizeWeight" [style.width.rem]="5"/>
                            </div>
                          </div>
                        </div>
                        <div class="column-list">
                          <div class="list-input-title layout_balance">
                            <label>原産国加工地</label>
                            <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                              <fa-icon [icon]="iconQuestion"></fa-icon></label>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [counterWidth]="'75px'" [maxChars]="200" id="txta_StringValue1"
                              #txta_StringValue1 [subid]="'txta_StringValue1'" [forcedEnabledMode]="'true'" [fullOnly]="true"
                              [allowMultiLine]="false" [tabindex]="0" [(ngModel)]="kymw1100Model.stringValue1" [height]="70">
                            </app-text-area>
                          </div>
                          <div class="list-input-title layout_balance" style="height:6rem;width: 174px;">
                            <label>原材料情報</label>
                            <label aria-label='誌面＋EC' data-microtip-position="top" role="tooltip" class="question">
                              <fa-icon [icon]="iconQuestion"></fa-icon></label>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [counterWidth]="'75px'" [maxChars]="2000" id="txta_StringValue2"
                              #txta_StringValue2 [subid]="'txta_StringValue2'" [forcedEnabledMode]="'true'" [fullOnly]="true"
                              [allowMultiLine]="false" [tabindex]="0" [(ngModel)]="kymw1100Model.stringValue2" [style.height.px]="84">
                            </app-text-area>
                          </div>
                          <div class="list-input-title layout_balance">
                            <label>コンタミ情報</label>
                            <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                              <fa-icon [icon]="iconQuestion"></fa-icon></label>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [counterWidth]="'75px'" [maxChars]="200" id="txta_StringValue3"
                              #txta_StringValue3 [subid]="'txta_StringValue3'" [forcedEnabledMode]="'true'" [fullOnly]="true"
                              [allowMultiLine]="false" [tabindex]="0" [(ngModel)]="kymw1100Model.stringValue3" [height]="70">
                            </app-text-area>
                          </div>
                          <div class="list-input-title layout_balance">
                            <label>添加物情報</label>
                            <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                              <fa-icon [icon]="iconQuestion"></fa-icon></label>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [counterWidth]="'75px'" [maxChars]="200" id="txta_StringValue5"
                              #txta_StringValue5 [subid]="'txta_StringValue5'" [forcedEnabledMode]="'true'" [fullOnly]="true"
                              [allowMultiLine]="false" [tabindex]="0" [(ngModel)]="kymw1100Model.stringValue5" [height]="70">
                            </app-text-area>
                          </div>
                          <div class="list-input-title">
                            <label>遺伝子組換表示区分</label>
                          </div>
                          <div class="list-input-content">
                            <app-code-combo-box [codeDiv]="'ct361'" [labelField]="'codeValueName'" id="cmb_GeneRecombinationDiv"
                              #cmb_GeneRecombinationDiv [subid]="'cmb_GeneRecombinationDiv'" [forcedEnabledMode]="'true'"
                              [tabindex]="0" [blank]="false" [width]="'5rem'"
                              [(ngModel)]="kymw1100Model.geneRecombinationDiv">
                            </app-code-combo-box>
                          </div>
                          <div class="list-input-title layout_balance">
                            <label>遺伝子組換</label>
                            <label aria-label='誌面＋EC：遺伝子組換表示区分="1"の場合' data-microtip-position="top" role="tooltip" class="question">
                              <fa-icon [icon]="iconQuestion"></fa-icon></label>
                          </div>
                          <div class="list-input-content">
                            <app-text-area [restrict]="'[ -￮]'" [counterWidth]="'75px'" [maxChars]="200" id="txta_StringValue6"
                              #txta_StringValue6 [subid]="'txta_StringValue6'" [forcedEnabledMode]="'true'" [fullOnly]="true"
                              [allowMultiLine]="false" [tabindex]="0" [(ngModel)]="kymw1100Model.stringValue6" [height]="70"
                              (keydown)="nextFocus($event)">
                            </app-text-area>
                          </div>
                        </div>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_Spec2Tab>仕様書２</a>
                    <div id="cnv_Spec2Tab" #cnv_Spec2Tab>
                      <div class="column-list">
                        <label class="list-input-title" style="width: 155px;">アレルゲン調査対象</label>
                        <div class="list-input-content">
                          <app-code-combo-box [codeDiv]="'ct313'" [labelField]="'codeValueName'" id="cmb_AllergenTargetType"
                            #cmb_AllergenTargetType [subid]="'cmb_AllergenTargetType'" [forcedEnabledMode]="'true'"
                            [tabindex]="0" [blank]="false" [disabled]="true" [(ngModel)]="kymw1100Model.allergenTargetType">
                          </app-code-combo-box>
                        </div>
  
                        <label class="list-input-title layout_balance">
                          <span>アレルゲン情報</span>
                          <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </label>
                        <div class="grid-container" [style.height.px]="!dispDialog ? 458: 440">
                          <wj-flex-grid #dtg_GoodsAllergenList [allowDragging]="'None'" [allowSorting]="false"
                            id="dtg_GoodsAllergenList" forcedEnabledMode="true" [tabindex]="0" [isReadOnly]="true"
                            [itemsSource]="kymw1100Model.allergenList" [headersVisibility]="'Column'"
                            (keydown)="nextFocus($event)" [style.width.px]="610">
                            <wj-flex-grid-column [minWidth]="5" [width]="60" [align]="'center'" [binding]="'Check'"
                              [header]="'表示'" [isReadOnly]="true">
                              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <input type="checkbox" [(ngModel)]="cell.item.Check"
                                  (change)="editAllergenTargetType(cell.item.Check, cell.item.PublishDiv);eventEditHandler()"
                                  id="cb_goods_algen_1_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                              </ng-template>
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [minWidth]="5" [width]="60" [align]="'center'" [binding]="'ComponentCheck'"
                              [header]="'含有'" [isReadOnly]="true">
                              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <input type="checkbox" (change)="eventEditHandler()" [(ngModel)]="cell.item.ComponentCheck"
                                  id="cb_goods_algen_2_{{cell.row.index}}" (mouseup)="$event.stopPropagation()" />
                              </ng-template>
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [minWidth]="5" [width]="471" [binding]="'AllergenName'" [header]="'アレルゲン'"
                              [isContentHtml]="true">
                              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <div [class.allergen-color]="cell.item.PublishDiv=='1'">
                                  {{cell.item.AllergenName}}
                                </div>
                              </ng-template>
                            </wj-flex-grid-column>
                          </wj-flex-grid>
                        </div>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_NutrientTab>栄養成分</a>
                    <div class="column-list" style="grid-template-columns: 100px auto;">
                      <div class="list-input-title layout_balance">
                        <label>分析単位</label>
                        <label aria-label="誌面＋EC" data-microtip-position="bottom" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <wj-flex-grid #dtg_NutrientUnitList id="dtg_NutrientUnitList" [allowDragging]="'None'"
                        [allowSorting]="false" [tabindex]="0" [style.height.px]="75"
                        [style.width.px]="660" [headersVisibility]="'None'" [itemsSource]="kymw1100Model.nutrientUnitList"
                        [isReadOnly]="true" [style.margin-top.px]="0">
                        <wj-flex-grid-column [minWidth]="5" [width]="'*'" [binding]="'AnalysisUnit'" [wordWrap]="true">
                        </wj-flex-grid-column>
                      </wj-flex-grid>
                      <div class="list-input-title layout_balance">
                        <label>栄養成分</label>
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label>
                      </div>
                      <div class="grid-container" [style.height.px]="!dispDialog ? 277: 259">
                        <wj-flex-grid #dtg_NutrientDetailList [allowDragging]="'None'" [allowSorting]="false"
                          class="list-input-content always-scrollbars" id="dtg_NutrientDetailList" [tabindex]="0"
                          [itemsSource]="kymw1100Model.nutrientDetailList" [isReadOnly]="true" [allowMerging]="'ColumnHeaders'"
                          [headersVisibility]="'Column'" [style.width.px]="660">
                          <wj-flex-grid-column [minWidth]="5" [width]="421" [binding]="'NutritionalName'" [header]="'栄養成分名'">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                              <div [class.nutritional-color]="cell.item.PublishDiv==='1'">
                                {{cell.item.NutritionalName}}
                              </div>
                            </ng-template>
                          </wj-flex-grid-column>
                          <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'NutritionalQuantity'" [header]="'栄養成分値'"
                            [align]="'right'">
                          </wj-flex-grid-column>
                          <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'NutritionalUnit'" [header]="'単位'">
                          </wj-flex-grid-column>
                        </wj-flex-grid>
                      </div>
  
                      <div class="list-input-title title-tooltip-column">
                        <label class="list-input-title" forcedEnabledMode="true">栄養成分備考</label>
                        <div class="layout_end">
                          <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                      </div>
                      <app-text-area [disabled]="true" plessInputTextSub [restrict]="'[ -￮]'" [maxChars]="200" [height]="115"
                        id="txta_NutritionalNote" [subid]="'txta_NutritionalNote'" [forcedEnabledMode]="'false'" [tabindex]="0"
                        [counterWidth]="'60px'" [(ngModel)]="kymw1100Model.nutritionalNote" [height]="90">
                      </app-text-area>
  
                      <label class="list-input-title">複数栄養成分</label>
                      <div class="list-input-content">
                        <app-checkbox-label id="chk_HasMultiNutrientInfo" #chk_HasMultiNutrientInfo
                          [subid]="'chk_HasMultiNutrientInfo'" [forcedEnabledMode]="'true'" [tabindex]="0"
                          [(ngModel)]="kymw1100Model.hasMultiNutrientInfo" label="複数あり"
                          (change)="eventHasMultiNutrientInfo_CLICKHandler()" (keydown)="nextFocus($event)">
                        </app-checkbox-label>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab [isDisabled]="!kymw1100Model.hasMultiNutrientInfo">
                    <a #a_MultiNutrientTab>複数栄養成分</a>
                    <div id="cnv_MultiNutrientTab" #cnv_MultiNutrientTab class="column-list"
                      style="grid-template-columns: 100px auto;">
                      <label class="list-input-title layout_balance">分析単位
                        <label aria-label="誌面＋EC" data-microtip-position="bottom" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label></label>
                      <wj-flex-grid #dtg_NutrientUnitListMulti id="dtg_NutrientUnitListMulti"
                        [style.height.px]="124" [style.width.px]="660" [allowDragging]="'None'" [allowSorting]="false"
                        [tabindex]="0" rowHeight="25" selectionColor="0xFFFFFF"
                        [itemsSource]="kymw1100Model.nutrientUnitListMulti" [isReadOnly]="true" [headersVisibility]="'None'"
                        (selectionChanged)="eventNutrientUnitListMulti_CHANGEHandler()">
                        <wj-flex-grid-column [minWidth]="5" [width]="'*'" [binding]="'AnalysisUnit'" [wordWrap]="true">
                        </wj-flex-grid-column>
                      </wj-flex-grid>
  
                      <label class="list-input-title layout_balance">栄養成分
                        <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                          <fa-icon [icon]="iconQuestion"></fa-icon></label></label>
                      <div class="grid-container" [style.height.px]="!dispDialog ? 265: 247">
                        <wj-flex-grid #dtg_NutrientDetailListMulti [allowDragging]="'None'" class="list-input-content always-scrollbars"
                          [allowSorting]="false" id="dtg_NutrientDetailListMulti" [tabindex]="0" [isReadOnly]="true"
                          [itemsSource]="kymw1100Model.nutrientDetailListMulti" [allowMerging]="'ColumnHeaders'"
                          [headersVisibility]="'Column'" (keydown)="nextFocus($event)" [style.width.px]="660">
                          <wj-flex-grid-column [minWidth]="5" [width]="421" [binding]="'NutritionalName'" [header]="'栄養成分名'">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                              <div [class.nutritional-color]="cell.item.PublishDiv==='1'">
                                {{cell.item.NutritionalName}}
                              </div>
                            </ng-template>
                          </wj-flex-grid-column>
                          <wj-flex-grid-column [minWidth]="5" [width]="120" [binding]="'NutritionalQuantity'" [header]="'栄養成分値'"
                            [align]="'right'">
                          </wj-flex-grid-column>
                          <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'NutritionalUnit'" [header]="'単位'">
                          </wj-flex-grid-column>
                        </wj-flex-grid>
                      </div>
  
                      <div class="list-input-title title-tooltip-column">
                        <label>栄養成分備考</label>
                        <div class="layout_end">
                          <label aria-label="誌面＋EC" data-microtip-position="top" role="tooltip" class="question">
                            <fa-icon [icon]="iconQuestion"></fa-icon></label>
                        </div>
                      </div>
                      <div class="list-input-content">
                        <app-text-area [disabled]="true" plessInputTextSub [restrict]="'[ -￮]'" [maxChars]="200" [height]="115"
                          id="txta_NutritionalNoteMulti" [subid]="'txta_NutritionalNoteMulti'" [counterWidth]="'60px'"
                          [forcedEnabledMode]="'false'" [tabindex]="0" [(ngModel)]="kymw1100Model.nutritionalNoteMulti" [height]="90">
                        </app-text-area>
                      </div>
                    </div>
                  </wj-tab>
  
                  <wj-tab>
                    <a #a_EcologyTab>環境関連</a>
                    <div id="cnv_EcologyTab" #cnv_EcologyTab>
                      <div class="column-list">
                        <label class="list-input-title">環境区分</label>
                        <div class="element-column">
                          <div class="block-row">
                            <app-radio-label label="なし" id="rdb_Ecology1" #rdb_Ecology1 [subid]="'rdb_Ecology1'"
                              name="radiogroup1" [forcedEnabledMode]="'true'" [tabindex]="0" [(ngModel)]="kymw1100Model.ecology"
                              value="1" (click)="eventEcology1Handler(null)"
                              (onfocus)="eventEcology1Handler(null)"></app-radio-label>
                            <app-radio-label label="あり" id="rdb_Ecology2" #rdb_Ecology2 [subid]="'rdb_Ecology2'"
                              name="radiogroup1" [forcedEnabledMode]="'true'" [tabindex]="0"
                              (click)="eventEcology2Handler(null)" [(ngModel)]="kymw1100Model.ecology" value="2"
                              (onfocus)="eventEcology2Handler(null)">
                            </app-radio-label>
                          </div>
  
                          <div class="grid-container" style="width:100%;" [style.height.px]="!dispDialog ? 182: 173">
                            <wj-flex-grid #dtg_GoodsEcologyList id="dtg_GoodsEcologyList" [allowDragging]="'None'"
                              [tabindex]="0" [allowSorting]="false" rowHeight="25" [style.width.px]="675"
                              [itemsSource]="kymw1100Model.goodsEcologyList" [isReadOnly]="true" [headersVisibility]="'Column'">
                              <wj-flex-grid-column [minWidth]="5" [width]="60" [align]="'center'" [binding]="'Check'"
                                [header]="'選択'" [isReadOnly]="true">
                                <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                  <input type="checkbox" [disabled]="!cell.item.Enabled" [(ngModel)]="cell.item.Check"
                                    (change)="eventEditHandler()" [tabindex]="-1" id="cb_goods_eco_{{cell.row.index}}"
                                    (mouseup)="$event.stopPropagation()" />
                                </ng-template>
                              </wj-flex-grid-column>
                              <wj-flex-grid-column [minWidth]="5" [width]="596" [binding]="'EcologyName'" [header]="'環境配慮商品'">
                              </wj-flex-grid-column>
                            </wj-flex-grid>
                          </div>
                        </div>
  
  
                        <label class="list-input-title">温暖化防止</label>
                        <div class="grid-container" style="height:86px;">
                          <wj-flex-grid #dtg_GoodsGWStopList id="dtg_GoodsGWStopList" [allowDragging]="'None'"
                            [allowSorting]="false" [tabindex]="0" rowHeight="25" [itemsSource]="kymw1100Model.goodsGWStopList"
                            [isReadOnly]="true" [headersVisibility]="'Column'" [style.width.px]="675">
                            <wj-flex-grid-column [minWidth]="5" [width]="60" [align]="'center'" [binding]="'Check'"
                              [header]="'選択'" [isReadOnly]="true">
                              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <input type="checkbox" [(ngModel)]="cell.item.Check" (change)="eventEditHandler()"
                                  [tabindex]="-1" id="cb_goods_gw_stop_{{cell.row.index}}"
                                  (mouseup)="$event.stopPropagation()" />
                              </ng-template>
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [minWidth]="5" [width]="598" [binding]="'GWStopName'" [header]="'温暖化防止'">
                            </wj-flex-grid-column>
                          </wj-flex-grid>
                        </div>
  
                        <label class="list-input-title">容器包装材</label>
                        <div class="grid-container" [style.height.px]="!dispDialog ? 182: 173">
                          <wj-flex-grid #dtg_ContainPackingList id="dtg_ContainPackingList" [allowDragging]="'None'"
                            [tabindex]="0" [allowSorting]="false" rowHeight="25" [isReadOnly]="true" [style.width.px]="675"
                            [itemsSource]="kymw1100Model.containPackingList" [headersVisibility]="'Column'">
                            <wj-flex-grid-column [minWidth]="5" [width]="60" [align]="'center'" [binding]="'Check'"
                              [header]="'選択'" [isReadOnly]="true">
                              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <input type="checkbox" [(ngModel)]="cell.item.Check"
                                  (change)="kymw1100Model.updateSelectedContainPackingInfo(cell.item);eventEditHandler()"
                                  [tabindex]="-1" id="cb_contain_pack_{{cell.row.index}}"
                                  (mouseup)="$event.stopPropagation()" />
                              </ng-template>
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [minWidth]="5" [width]="70" [binding]="'ContainDiv'" [header]="'区分'">
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [minWidth]="5" [width]="168" [binding]="'ContainDivName'" [header]="'区分名'">
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [minWidth]="5" [width]="70" [binding]="'ContainKind'" [header]="'素材'">
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [minWidth]="5" [width]="188" [binding]="'ContainKindName'" [header]="'素材名'">
                            </wj-flex-grid-column>
                            <wj-flex-grid-column [minWidth]="5" [width]="100" [binding]="'PackMaterialWeight'" [header]="'重量'"
                              [align]="'right'">
                              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <input type="text" [style.text-align]="'right'" [style.width.%]="'100'" autocomplete="off"
                                  [maxLength]="7" plessInputTextSub [restrict]="'[0-9.]'" [disabled]="!cell.item.Check"
                                  [(ngModel)]="cell.item.PackMaterialWeight" (change)="eventEditHandler()" [tabindex]="-1" />
                              </ng-template>
                            </wj-flex-grid-column>
                          </wj-flex-grid>
                        </div>
                      </div>
                    </div>
                  </wj-tab>
                </div>
              </wj-tab-panel>
            </div>
          </div>
        </div>
      </wj-tab>
    </wj-tab-panel>
  </div>
  
  <footer class="footer-buttons" *ngIf="!dispDialog">
    <button id="btn_Out" class="btn-secondary" #btn_Out [disabled]="!kymw1100Model.btnOutEnabled"
      (click)="eventOutHandler()" forcedEnabledMode="none" [tabindex]="0">出力</button>
    <button id="btn_Delete" #btn_Delete class="btn-tartiary warning" [disabled]="true" [tabindex]="0"
      (click)="eventDelete_CLICKHandler()">削除</button>
    <button id="btn_eBASE" #btn_eBASE class="btn-secondary" forcedEnabledMode="none" [tabindex]="0"
      (click)="eventEBASE_CLICKHandler()">eBASEデータ</button>
    <button id="btn_Print" #btn_Print [tabindex]="0" class="btn-secondary" forcedEnabledMode="true"
      (click)="eventPrint_CLICKHandler()" (keydown)="initTabKey($event)">印刷</button>
    <button id="btn_StatusUpdate" class="btn-primary" #btn_StatusUpdate forcedEnabledMode="none" [tabindex]="0"
      (click)="eventStatusUpdate_CLICKHandler()">更新</button>
  </footer>
</ng-template>